/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, useCallback, SetStateAction, useMemo } from "react";
import { Map as ImmutableMap } from 'immutable';
import {
  makeStyles,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Collapse,
  NativeSelect,
  InputLabel,
  FormControl,
  FormControlLabel,
  IconButton,
  Button,
  Tooltip,
} from "@material-ui/core";
import { Apps, ArrowDownward, ArrowUpward, ExpandLess, ExpandMore, FilterList, Fullscreen, KeyboardArrowDown, KeyboardArrowUp, Reorder } from "@material-ui/icons";
// import hash from "object-hash";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  CallEvent,
  Summary,
  UserPresenceEvent,
  Historical,
  QueuePresenceEvent,
  Delta,
  QueueCallState,
  UserState,
} from "./QueueLeaderboard";

import Widget from "./Widget";
import UserWidget from "./User";
import View from "./View";
import { CXAgent } from "./CxDashboard";
import ActiveFilterView from "./timeline/ActiveFilterView";
import NewLeaderboard from "./NewLeaderboard";
import Groups, { IWidgetData } from "./NEW/Groups/Groups";
import QueueWidgetContainer, { MetricObject } from "./QueueWidgetContainer";
import RcButton from "./UiUtilities/Button";
import CompactViewHeader from "./NEW/CompactViewHeader";
import UserHeadlines from "./headlines/UserHeadlines";
import IvrHud, { HistoricalIvr, IvrState } from "./IvrSummary/IvrHud";
 // import WidgetVTwo from "./WidgetVTwo";
import newUi from './styles/Sidebar.module.css'

interface CallSummaryEvent {
  code: string;
  reason?: string;
  timestamp: Date;
  from?: {
    name?: string;
    phoneNumber: string;
    extensionNumber?: string;
  };
  telephonySessionId: string;
  direction: string;
  to?: {
    name?: string;
    phoneNumber: string;
    extensionNumber?: string;
  };
  acw?: {
    duration: string;
    label: string;
  };
}

interface Call {
  id: string;
  startTime?: string;
  toName?: string;
  toNumber?: string;
  fromName?: string;
  fromNumber?: string;
  outbound?: boolean;
  inbound?: boolean;
}

interface User {
  id: string;
  display?: string;
  lastName?: string;
  firstName?: string;
  department?: string;
  site?: {
    name: string;
  };
  extensionNumber?: string;
  lastDndStatus?: string;
  lastPresenceStatus?: string;
  messageTimestamp?: string;
  signedUrl?: string;
  status?: string;
  glipStatus?: string;
  type?: string;
  emergency?: boolean;
  queues?: Array<{
    queueId: string;
    name: string;
    acceptCurrentQueueCalls?: boolean;
  }>;
  state?: UserState;
  uri?: string;
  late?: boolean | undefined;
  timerInfo?: any;
}

interface Queue {
  id: string;
  users: Array<{ id: string; acceptCurrentQueueCalls: boolean }>;
  extensionNumber: string;
  name: string;
}

const finishedCalls = new Map<string, Set<string>>();
const myFinishedCalls = new Map<string, Set<string>>();
const users = new Map<string, User>();

const unprocessed = new Map<string, User>();
const queues = new Map<string, Queue>();

// let inProgressDelta: string;
// const missedDeltas = new Map<string, Array<Delta>>();

const useStyles = makeStyles((theme) => ({
  widgetCell: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    [theme.breakpoints.up(600)]: {
      width: "calc(50% - 5px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(33.3333333% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(25% - 10px)",
    },
  },
  widgetCellSidebar: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    [theme.breakpoints.up(0)]: {
      display: "none",
    },
    [theme.breakpoints.up(600)]: {
      width: "calc(100% - 10px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(50% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(33.3333333% - 10px)",
    },
  },
  leaderboard: {
    width: "calc(100% - 5px)",
    margin: 5,
    float: "left",
  },
  leaderboardSidebar: {
    width: "calc(100% - 5px)",
    margin: 5,
    float: "left",
    display: "none",
    [theme.breakpoints.up(600)]: {
      width: "calc(100% - 0px)",
      display: "block",
    },
    // [theme.breakpoints.up(900)]: {
    //   width: 'calc(50% - 10px)',
    // },
    // [theme.breakpoints.up(1200)]: {
    //   width: 'calc(33.3333333% - 10px)',
    // },
  },
  nested: {
    padding: "2px 0 2px 16px",
    height: 32,
  },
  listText: {
    fontSize: "0.85rem",
  },
  sidebarPanel: {
    width: "calc(100%)",
    animation: "fade-sidebar-full-screen 0.1s ease forwards",
    [theme.breakpoints.up(600)]: {
      width: "calc(50%)",
      marginTop: '20px',
      animation: "fade-sidebar-half-screen 0.1s ease forwards", 
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(33.3333333%)",
      animation: "fade-sidebar-third-screen 0.1s ease forwards",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(25%)",
      animation: "fade-sidebar-quarter-screen 0.1s ease forwards",
    },
    position: "fixed",
    right: 0,
    top: 0,
    height: "100%",
    color: "white",
    fontFamily: "roboto",
    overflowY: "auto",
  },
  widgetPanel: {
    [theme.breakpoints.up(0)]: {
      display: "none",
    },
    [theme.breakpoints.up(600)]: {
      width: "calc(50% - 10px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(66.6666666% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(75% - 10px)",
    },
    height: "100%",
  },
  body: {
    marginTop: 0,
    marginBottom: 0,
  },
  formControl: {

  },
  formControlDark: {

  },
  select: {
    padding: "5px 24px 5px 5px",
    border: "1px solid black",
    borderRadius: 5,
    backgroundColor: "white",
    color: "black",
    "&:focus": {
      backgroundColor: "white",
      border: "1px solid black",
      borderRadius: 5,
    },
  },
  selectDark: {
    padding: "5px 24px 5px 5px",
    border: "1px solid white",
    borderRadius: 5,
    backgroundColor: "#282828",
    color: "white",
    "&:focus": {
      backgroundColor: "#282828",
      border: "1px solid white",
      borderRadius: 5,
    },
    "& option": {
      backgroundColor: "#282828 !important",
    },
  },
  icon: {
    color: "black",
  },
  iconDark: {
    color: "white",
  },
  search: {
    "& input": {
      padding: 5,
    },
    "& > div": {
      padding: 5,
    },
    backgroundColor: "white",
    borderRadius: 5,
  },
}));

const useNewStyles = makeStyles((theme) => ({
  widgetCell: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    [theme.breakpoints.up(600)]: {
      width: "calc(50% - 10px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(33.3333333% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(25% - 10px)",
    },
  },
  widgetCellSidebar: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    [theme.breakpoints.up(0)]: {
      display: "none",
    },
    [theme.breakpoints.up(600)]: {
      width: "calc(100% - 10px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(50% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(33.3333333% - 10px)",
    },
  },
  leaderboard: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    transitionDuration: '0.1s'
  },
  leaderboardSidebar: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    display: "none",
    [theme.breakpoints.up(600)]: {
      width: "calc(100% - 10px)",
      transitionDuration: '0.1s',
      display: "block",
    },
    // [theme.breakpoints.up(900)]: {
    //   width: 'calc(50% - 10px)',
    // },
    // [theme.breakpoints.up(1200)]: {
    //   width: 'calc(33.3333333% - 10px)',
    // },
  },
  nested: {
    padding: "2px 0 2px 16px",
    height: 32,
  },
  listText: {
    fontSize: "0.85rem",
  },
  sidebarPanel: {
    width: "calc(100%)",
    [theme.breakpoints.up(600)]: {
      width: "calc(50%)",
      marginTop: '20px',
      transitionDuration: '0.2s'
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(33.3333333%)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(25%)",
      transitionDuration: '0.2s'
    },
    position: "fixed",
    right: 0,
    top: 0,
    height: "100%",
    color: "white",
    fontFamily: "roboto",
    overflowY: "auto",
  },
  widgetPanel: {
    [theme.breakpoints.up(0)]: {
      display: "none",
    },
    [theme.breakpoints.up(600)]: {
      width: "calc(50% - 0px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(66.6666666% - 0px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(75% - 0px)",
    },
    height: "100%",
  },
  body: {
    marginTop: 0,
    marginBottom: 0,
  },
  select: {
    padding: "5px 24px 5px 5px",
    border: "1px solid black",
    borderRadius: 5,
    backgroundColor: "white",
    color: "black",
    "&:focus": {
      backgroundColor: "white",
      border: "1px solid black",
      borderRadius: 5,
    },
  },
  formControl: {
    width: '100%',
  },
  formControlDark: {
    width: '100%',
    [theme.breakpoints.up(0)]: {
      width: '100%'
    },
    [theme.breakpoints.up(900)]: {
      width: '50%',
    }
  },
  selectDark: {
    padding: "5px 24px 5px 5px",
    border: "1px solid #666",
    borderRadius: 5,
    backgroundColor: "#282828",
    color: "white",

    "&:focus": {
      backgroundColor: "#282828",
      border: "1px solid white",
      borderRadius: 5,
    },
    "& option": {
      backgroundColor: "#282828 !important",
    },
  },
  icon: {
    color: "black",
  },
  iconDark: {
    color: "white",
  },
  search: {
    "& input": {
      padding: 5,
    },
    "& > div": {
      padding: 5,
    },
    backgroundColor: "white",
    borderRadius: 5,
  },
}));



  export const sidebarDescAscStyleHandler = (lightMode: boolean) => {
    if (lightMode) {
      return {  backgroundColor: 'white', color: 'black'}
    }
     return { backgroundColor: '#282828'}
  }

const defaultWidgetMetrics = [
  { key: 'available-agents', label: 'Available Agents', visible: false },
  { key: 'busy-agents', label: 'Busy Agents', visible: false  },
  { key: 'unavailable-agents', label: 'Unavailable Agents', visible: false  },
  { key: 'agent-count', label: 'Total Agents', visible: false  },
  { key: 'waiting-count', label: 'Waiting Calls', visible: false  },
  { key: 'longest-waiting', label: 'Longest Waiting' , visible: false },
  { key: 'answered-count', label: 'Answered Calls', visible: false },
  { key: 'answered-pct', label: 'Answered %', visible: false  },
  { key: 'abandoned-count', label: 'Abandoned Calls', visible: false },
  { key: 'abandoned-pct', label: 'Abandoned %', visible: false  },
  { key: 'voicemail-count', label: 'Voicemail Calls', visible: false },
  { key: 'voicemail-pct', label: 'Voicemail %', visible: false  },
  { key: 'other-count', label: 'Other Calls', visible: false },
  { key: 'other-pct', label: 'Other %', visible: false  },
  { key: 'call-count', label: 'Total Calls', visible: false  },
]

const Hud = React.memo(({
  doubleWidgets,
  setUserLeaderboardApi,
  ivrSummary,
  historicalIvr,
  ivrStates,
  ivrDeltas,
  smsData,
  idToken,
  setQueueCallStates,
  historicals,
  presenceEvents,
  queuePresenceEvents,
  summaries,
  historicalUsers,
  historicalQueues,
  excluded,
  setExcluded,
  id,
  origin,
  mode,
  showDnd,
  showBusy,
  showInvisible,
  showAvailable,
  setShowAvailable,
  setShowBusy,
  setShowDnd,
  setShowInvisible,
  tab,
  sidebar,
  isAdmin,
  changeTab,
  setProfileId,
  local,
  rcId,
  updateLocal,
  showLeaderboards,
  elapsedTime,
  hasPresenceTimer,
  offset,
  callEvents,
  leaderboards,
  isVisible,
  acw,
  forwardAddress,
  organizationId,
  setTimer,
  page,
  leaderboardDeltas,
  queueCallStates,
  showHandRaise,
  supervise,
  vipList,
  navPage,
  excludedUsers,
  setExcludedUsers,
  excludedIvrs,
  setExcludedIvrs,
  excludedAirs,
  setExcludedAirs,
  userStates,
  hasRingCx,
  apiUrl,
  forceAvailable,
  activeFilterRef,
  legacyUI,
  rcAccessToken,
  queueCompactView,
  setQueueCompactView,
  fullscreen,
  setFullscreen,
  setDialer,
  userState,
  cxAgents,
  profileId,
  setLiveQueueMetrics
}: {
  doubleWidgets: boolean,
  setUserLeaderboardApi: any,
  ivrSummary: boolean,
  historicalIvr: ImmutableMap<string, HistoricalIvr>,
  ivrStates: IvrState[],
  ivrDeltas: Delta[],
  smsData: any;
  idToken: string;
  setQueueCallStates: any;
  historicals: Array<Historical>;
  presenceEvents: Array<UserPresenceEvent>;
  queuePresenceEvents: Array<QueuePresenceEvent>;
  excludedUsers: Set<string> | undefined;
  setExcludedUsers: React.Dispatch<
    React.SetStateAction<Set<string> | undefined>
  >;
  excluded: Set<string> | undefined;
  setExcluded: React.Dispatch<React.SetStateAction<Set<string> | undefined>>;

  excludedIvrs: Set<string>;
  setExcludedIvrs:  React.Dispatch<React.SetStateAction<Set<string>>>;

  excludedAirs: Set<string>;
  setExcludedAirs:  React.Dispatch<React.SetStateAction<Set<string>>>;

  isVisible: boolean;
  leaderboards: boolean | undefined;

  summaries: Array<Summary>;
  historicalUsers: ImmutableMap<string, any>;
  historicalQueues: ImmutableMap<string, any>;
  id: string;
  origin: string;
  mode: string;
  showDnd: boolean;
  showBusy: boolean;
  showInvisible: boolean;
  showAvailable: boolean;
  setShowDnd: React.Dispatch<SetStateAction<any>>;
  setShowBusy: React.Dispatch<SetStateAction<any>>;
  setShowInvisible: React.Dispatch<SetStateAction<any>>;
  setShowAvailable: React.Dispatch<SetStateAction<any>>;
  tab: string;
  sidebar: boolean;
  isAdmin: boolean;
  changeTab: string | undefined;
  setProfileId: any;
  profileId: any;
  local: any;
  rcId: string;
  updateLocal: any;
  showLeaderboards: boolean | undefined;
  setLiveQueueMetrics: React.Dispatch<SetStateAction<Map<string, MetricObject>>>;
  elapsedTime: string;
  hasPresenceTimer: boolean;
  offset: number;
  callEvents: Array<CallEvent>;
  queueCallStates: Array<QueueCallState>;
  acw: Map<string, { duration: string; label: string }>;

  organizationId: string;
  setTimer: React.Dispatch<
    React.SetStateAction<
      { duration: string; id: string; endTimestamp?: string } | undefined
    >
  >;
  forwardAddress: string;
  page: string;
  leaderboardDeltas: Array<Delta>;
  showHandRaise: boolean;
  supervise: boolean;
  vipList: any;
  navPage: string;
  userStates: ImmutableMap<string, UserState>;
  hasRingCx: boolean;
  apiUrl: string;
  forceAvailable: boolean;
  activeFilterRef: { [colId: string]: any };
  legacyUI: boolean,
  rcAccessToken: string,
  queueCompactView: boolean;
  setQueueCompactView: React.Dispatch<SetStateAction<boolean>>;
  fullscreen: undefined | string;
  setFullscreen: React.Dispatch<SetStateAction<string | undefined>>
  setDialer: React.Dispatch<SetStateAction<any>>;
  userState: ImmutableMap<string, UserState>;
  cxAgents: CXAgent[] | undefined;
}) => {
  const [displayHeadlines, setDisplayHeadlines] = useState<boolean>(false)
  const [headlinesAnchorEl, setHeadlinesAnchorEl] = useState(false)
  const [blocked, setBlocked] = useState<Set<string> | undefined>(); // ie Users
  const [blockedQueues, setBlockedQueues] = useState<Set<string> | undefined>();
  const [blockedDepartments, setBlockedDepartments] = useState<
    Set<string> | undefined
  >();
  const [excludedDepartments, setExcludedDepartments] = useState<
    Set<string> | undefined
  >();
  const [blockedLocations, setBlockedLocations] = useState<
    Set<string> | undefined
  >();
  const [excludedLocations, setExcludedLocations] = useState<
    Set<string> | undefined
  >();
  const [checked, setChecked] = useState<Set<string> | undefined>();
  const [open, setOpen] = useState<string>("");
  const [backgroundColor, setBackgroundColor] = useState<string>("#0684bd");
  const [userDisplay, setUserDisplay] = useState<string | undefined>();
  // functions don't seem to work default-wise
  const [userSort, setUserSort] = useState<any>();
  const [userFormat, setUserFormat] = useState<any>();
  const [userSortField, setUserSortField] = useState<string | undefined>();
  const [userSortDirection, setUserSortDirection] = useState<
    string | undefined
  >();
  const [queueDisplay, setQueueDisplay] = useState<string | undefined>();
  const [queueSort, setQueueSort] = useState<any>();
  const [queueSortField, setQueueSortField] = useState<string | undefined>();
  const [queueSortDirection, setQueueSortDirection] = useState<
    string | undefined
  >();
  const [departmentSortDirection, setDepartmentSortDirection] = useState<
    string | undefined
  >();
  const [locationSortDirection, setLocationSortDirection] = useState<
    string | undefined
  >();
  const [departmentSort, setDepartmentSort] = useState<any>();
  const [locationSort, setLocationSort] = useState<any>();
  const [showPortraits, setShowPortraits] = useState<boolean | undefined>();
  const [userSearch, setUserSearch] = useState<string>("");

  const [ivrSearch, setIvrSearch] = useState<string>("")
  const [ivrSort, setIvrSort] = useState<any>()
  const [ivrSortField, setIvrSortField] = useState<string | undefined>("extensionNumber")
  const [ivrSortDirection, setIvrSortDirection] = useState<string | undefined>("asc")
  const [blockedIvrs, setBlockedIvrs] = useState<Set<string>>(new Set<string>())

  const [airSearch, setAirSearch] = useState<string>("")
  const [airSort, setAirSort] = useState<any>();
  const [airSortField, setAirSortField] = useState<string | undefined>("extensionNumber")
  const [airSortDirection, setAirSortDirection] = useState<string | undefined>("asc")
  const [blockedAirs, setBlockedAirs] = useState<Set<string>>(new Set<string>())
 
  const [queueSearch, setQueueSearch] = useState<string>("");
  const [departmentSearch, setDepartmentSearch] = useState<string>("");
  const [locationSearch, setLocationSearch] = useState<string>("");
  const [queueFormatSidebar, setQueueFormatSidebar] = useState<any>();
  const [expandQueues, setExpandQueues] = useState<boolean>(true);
  const [expandUsers, setExpandUsers] = useState<boolean>(true)
  const [compactWidgetMetricsView, setCompactWidgetMetricsView] = useState(false)
  const [compactWidgetMetrics, setCompactWidgetMetrics] = useState<Array<{key: string, label: string, visible: boolean}> | undefined>(undefined)
  // FacilityId Stuff

  const [blockedFacilities, setBlockedFacilities] = useState<Set<string>>(new Set<string>());
  const [excludedFacilities, setExcludedFacilities] = useState<
    Set<string>
  >(new Set<string>());
  const [facilitySortDirection, setFacilitySortDirection] = useState<
    string
  >("asc");
  const [facilitySort, setFacilitySort] = useState<any>();
  const [facilitySearch, setFacilitySearch] = useState<string>("");

  // const [calls, setCalls] = useState<
  //   Map<string, Map<string, Array<CallSummaryEvent>>>
  // >(new Map());
  const [callsByIndex, setCallsByIndex] = useState<
    Map<
      string,
      {
        acw?: { duration: string; label: string };
        calls: Map<string, Array<CallSummaryEvent>>;
      }
    >
  >(new Map());
  const [me, setMe] = useState<{
    id: string;
    display: string;
    lastName: string;
    firstName: string;
    extensionNumber: string;
    lastDndStatus: string;
    messageTimestamp: string;
    signedUrl?: string;
    recentlyIdle?: boolean;
  }>();

  const [widgetData, setWidgetData] = useState<
    | Array<{
      id: string;
      firstName: string;
      lastName: string;
      extensionNumber: string;
      department: string;
      location: string;
      uri: string;
      messageTimestamp?: number;
      status: string;
      glipStatus: string;
      type: string;
      lastPresenceStatus: string;
      lastDndStatus: string;
      emergency: boolean;
      display?: string;
      queues?: Array<{
        queueId: string;
        name: string;
        acceptCurrentQueueCalls?: boolean;
      }>;
      late?: boolean;
    }>
    | undefined
  >();
  const [openPopperUserId, setOpenPopperUserId] = useState<string | null>(null);
  const [toggledQueues, setToggledQueues] = useState<Map<string, string>>(new Map())


  const [historicalDepartments] = useState(() =>
    historicalUsers
      .valueSeq()
      .map((user) => user.department)
      .filter((department) => department) // Remove undefined or falsy values
      .toSet() // Collect unique values
      .toMap() // Convert to a Map
      .map((name) => ({ id: name, name })) // Map to the desired structure
  );

  const [historicalLocations] = useState(() =>
    historicalUsers
      .valueSeq()
      .map((user) => user.site?.name)
      .filter((siteName) => siteName) // Remove undefined or falsy values
      .toSet() // Collect unique site names
      .toMap() // Convert to an ImmutableMap
      .map((name) => ({ id: name, name })) // Map to objects with `id` and `name`
  );

  const [historicalFacilities] = useState(() =>
    historicalUsers
      .valueSeq()
      .map((user) => user.facilityId)
      .filter((facilityId) => facilityId) // Remove undefined or falsy values
      .toSet() // Collect unique facility IDs
      .toMap() // Convert to an ImmutableMap
      .map((name) => ({ id: name, name })) // Map to objects with `id` and `name`
  );
  const queueFormat = useCallback((queue: any) => {
    if (queueDisplay === "name-ext") {
      return (
        <div>
          {queue.name || ""}
          <br />
          {queue.extensionNumber || ""}
        </div>
      );
    }
    return (
      <div>
        {queue.extensionNumber || ""}
        <br />
        {queue.name || ""}
      </div>
    );
  }, [queueDisplay]);

  const handlePopupToggle = useCallback((userId: string) => {
    setOpenPopperUserId((prevUserId) =>
      prevUserId === userId ? null : userId
    );
  }, []);

  // useEffect(() => {
  //   // shows each state once and only once
  //   // most recent state for a user should take precedence

  //   if (userStates) {
  //     setUserStateMap((oldUserStateMap) => {
  //       const tempMap = new Map(oldUserStateMap);

  //       userStates.forEach((element) => {
  //         const oldSequence = tempMap.get(element.userId)?.sequence;
  //         const oldTime = tempMap.get(element.userId)?.time;

  //         if (
  //           oldSequence === undefined ||
  //           oldTime === undefined ||
  //           (element.time === oldTime && element.sequence > oldSequence) ||
  //           element.time > oldTime
  //         ) {
  //           tempMap.set(element.userId, element);

  //           if (element.userId === rcId && element.state === "IDLE") {
  //             setMe((oldMe) =>
  //               oldMe === undefined
  //                 ? undefined
  //                 : {
  //                   ...oldMe,
  //                   recentlyIdle: true,
  //                 }
  //             );
  //           }
  //         }
  //       });
  //       return tempMap;

  //     });
  //   }
  // }, [userStates]);


  useEffect(() => {
    if (rcId) {
      const getToggledQueuesFromStorage = localStorage.getItem(`toggled-queues-${rcId}`);
      const toggledQueuesToJson = JSON.parse(getToggledQueuesFromStorage || "[]")
      setToggledQueues(new Map(toggledQueuesToJson?.map((i: string) => [i, i])))
    }
  }, [rcId])

  useEffect(() => {
    if (rcId) localStorage.setItem(`toggled-queues-${rcId}`, JSON.stringify(Array.from(toggledQueues?.values())))
  }, [toggledQueues])

  useEffect(() => {
    if (!forceAvailable) {
      return;
    }
    if (me?.recentlyIdle && me?.display.startsWith("BSY:")) {
      setMe((oldMe) => ({
        ...oldMe!,
        recentlyIdle: false,
      }));
      (async () => {
        // window.parent.postMessage(
        //   JSON.stringify({
        //     event: "flash-message",
        //     userStatus: "Available",
        //     message: "AVL:Available",
        //     id: rcId,
        //   }),
        //   origin
        // );

        await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
          method: "POST",
          body: JSON.stringify({
            message: `AVL:Available`,
            userStatus: "Available",
            id: rcId,
            token: rcAccessToken,
          }),
          headers: {
            authorization: idToken || "",
          }
        });

        await fetch(forwardAddress, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
            body: {
              presenceStatus: "Available",
              message: "AVL:Available",
            },
            send: true,
          }),
        });
      })();
    }
  }, [me]);

  // console.log(me, userStateMap);

  useEffect(() => {
    setMe(historicalUsers.get(rcId));
  }, [historicalUsers]);

  // useEffect(() => {
  //   if (summaries?.[0]?.userStates) {
  //     setUserStateMap((oldUserStateMap) => {
  //       const tempMap = new Map(oldUserStateMap);

  //       summaries[0].userStates.forEach((element) => {
  //         const oldSequence = tempMap.get(element.userId)?.sequence;
  //         const oldTime = tempMap.get(element.userId)?.time;

  //         if (
  //           oldSequence === undefined ||
  //           oldTime === undefined ||
  //           (element.time === oldTime && element.sequence > oldSequence) ||
  //           element.time > oldTime
  //         ) {
  //           tempMap.set(element.userId, element);
  //         }
  //       });
  //       return tempMap;
  //     });
  //   }
  // }, [summaries]);

  const filterUsers = useCallback(() => {
    if (excluded === undefined) {
      return Array.from(users.values());
    }

    if (checked === undefined) {
      return Array.from(users.values());
    }

    if (blockedQueues === undefined) {
      return Array.from(users.values());
    }

    if (excludedUsers === undefined) {
      return Array.from(users.values());
    }

    const filteredByPresence = Array.from(users.values()).filter(
      (myHistoricalUser: User) => {
        if (myHistoricalUser.lastDndStatus === "DoNotAcceptAnyCalls") {
          return showDnd;
        }

        if (myHistoricalUser.lastPresenceStatus === "Busy") {
          return showBusy;
        }

        if (myHistoricalUser.lastPresenceStatus === "Offline") {
          return showInvisible;
        }

        return showAvailable;
      }
    );

    const filteredByQueues = filteredByPresence
      .map((myHistoricalUser) => {
        const myQueues = Array.from(queues.values()).filter(
          ({ users: myUsers }) =>
            myUsers.find((user: any) => user.id === myHistoricalUser.id)
        );

        if (myQueues.length) {
          return {
            ...myHistoricalUser,
            queues: myQueues
              .filter(
                (queue) =>
                  !excluded.has(queue.id) && !blockedQueues.has(queue.id)
              )
              .map((queue) => ({
                acceptCurrentQueueCalls: queue.users.find(
                  (user: any) => user.id === myHistoricalUser.id
                )?.acceptCurrentQueueCalls,
                queueId: queue.id,
                name: queue.name,
              })),
          };
        }
        return myHistoricalUser;
      })
      .filter((item) => {
        if (tab === "queues") {
          return item.queues && item.queues.length !== 0;
        }
        return item;
      });

    const filteredUsers = filteredByQueues.filter((user) => {
      if (tab === "queues") {
        return true;
      }

      if (excludedUsers.has(user.id)) {
        return false;
      }

      return true;
    });

    return filteredUsers;
  }, [
    checked,
    excluded,
    showAvailable,
    showBusy,
    showDnd,
    showInvisible,
    tab,
    blockedQueues,
    excludedUsers,
  ]);

  useEffect(() => {
    const record = callEvents[0];
    if (record === undefined) {
      return;
    }

    setCallsByIndex(
      (
        oldCalls: Map<
          string,
          {
            acw?: { duration: string; label: string };
            calls: Map<string, Array<CallSummaryEvent>>;
          }
        >
      ) => {
        const newCalls = new Map(oldCalls);
        // can't trust the basic extension id to be accurate
        const myCalls = {
          ...(newCalls.get(record.body.telephonySessionId) || {
            calls: new Map() as Map<string, Array<CallSummaryEvent>>,
          }),
          acw: acw.get(
            record.body.parties[0].to?.extensionId ||
            record.body.parties[0].from?.extensionId ||
            ""
          ),
        };

        const temp = new Map(myCalls.calls);

        const myEvents = Array.from(
          temp.get(record.body.parties[0].extensionId) || []
        );

        myEvents.push({
          code: record.body.parties[0].status.code,
          reason: record.body.parties[0].status.reason,
          timestamp: new Date(record.body.eventTime),
          from: record.body.parties[0].from,
          telephonySessionId: record.body.telephonySessionId,
          direction: record.body.parties[0].direction,
          to: record.body.parties[0].to,
        });

        myEvents.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());

        if (
          record.body.parties[0].status.code === "Voicemail" ||
          ((record.body.parties[0].status.code === "Disconnected" ||
            record.body.parties[0].status.code === "Gone") &&
            record.body.parties[0].status.reason !== "CallerInputRedirect" &&
            record.body.parties[0].status.reason !== "CallSwitch")
        ) {
          if (
            record.body.parties[0].extensionId === rcId &&
            (record.body.parties[0].status.code === "Disconnected" ||
              record.body.parties[0].status.code === "Gone") &&
            record.body.parties[0].status.reason !== "CallSwitch" &&
            myEvents.find(
              (event) =>
                event.code === "Answered" && event.direction === "Inbound"
            )
          ) {
            if (myCalls.acw !== undefined) {
              setTimeout(async () => {

                await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
                  method: "POST",
                  body: JSON.stringify({
                    dndStatus: "DoNotAcceptAnyCalls",
                    message: `DND:${myCalls.acw?.label}`,
                    userStatus: "Busy",
                    id: rcId,
                    token: rcAccessToken,
                  }),
                  headers: {
                    authorization: idToken || "",
                  }
                });
                // window.parent.postMessage(
                //   JSON.stringify({
                //     event: "flash-message",
                //     userStatus: "Busy",
                //     dndStatus: "DoNotAcceptAnyCalls",
                //     message: `DND:${myCalls.acw?.label}`,
                //     id: rcId,
                //     timer: true,
                //   }),
                //   origin
                // );

                if (myCalls.acw?.duration) {
                  setTimer({
                    duration: parseInt(myCalls.acw.duration, 10).toString(),
                    id: rcId,
                  });
                }

                // tell SA
                await fetch(apiUrl, {
                  method: "post",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
                    body: {
                      dndStatus: "DoNotAcceptAnyCalls",
                      presenceStatus: "Busy",
                      message: `DND:${myCalls.acw?.label}`,
                    },
                    send: true,
                  }),
                });
              }, 5000);
            }
          }
          temp.delete(record.body.parties[0].extensionId);
        } else {
          temp.set(record.body.parties[0].extensionId, myEvents);
        }

        if (temp.size === 0) {
          newCalls.delete(record.body.telephonySessionId);
        } else {
          newCalls.set(record.body.telephonySessionId, {
            acw: myCalls.acw,
            calls: temp,
          });
        }

        return newCalls;
      }
    );
  }, [callEvents, acw, rcId, apiUrl, organizationId, setTimer]);

  // useEffect(() => {
  //   acwEvents?.forEach((acwEvent) => {
  //     setTimeout(async () => {
  //       // window.parent.postMessage(
  //       //   JSON.stringify({
  //       //     event: "flash-message",
  //       //     userStatus: "Busy",
  //       //     dndStatus: "DoNotAcceptAnyCalls",
  //       //     message: `DND:${acwEvent.label}`,
  //       //     id: rcId,
  //       //     timer: true,
  //       //   }),
  //       //   origin
  //       // );

  //       await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
  //         method: "POST",
  //         body: JSON.stringify({
  //           dndStatus: "DoNotAcceptAnyCalls",
  //           message: `DND:${acwEvent.label}`,
  //           userStatus: "Busy",
  //           id: rcId,
  //           token: rcAccessToken,
  //         }),
  //         headers: {
  //           authorization: idToken || "",
  //         }
  //       });

  //       if (acwEvent.duration) {
  //         setTimer({
  //           duration: parseInt(acwEvent.duration, 10).toString(),
  //           id: rcId,
  //         });
  //       }

  //       // tell SA
  //       await fetch(apiUrl, {
  //         method: "post",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
  //           body: {
  //             dndStatus: "DoNotAcceptAnyCalls",
  //             presenceStatus: "Busy",
  //             message: `DND:${acwEvent.label}`,
  //           },
  //           send: true,
  //         }),
  //       });
  //     }, 5000);
  //   });
  // }, [acwEvents]);

  useEffect(() => {
    if (excludedUsers === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-excludedUsers`,
      JSON.stringify(Array.from(excludedUsers))
    );
  }, [excludedUsers, updateLocal]);

  useEffect(() => {
    if (showLeaderboards === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-leaderboards`,
      showLeaderboards.toString()
    );
  }, [showLeaderboards, updateLocal]);

  useEffect(() => {
    if (blocked === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-blocked`,
      JSON.stringify(Array.from(blocked))
    );
  }, [blocked, updateLocal]);

  useEffect(() => {
    if (blockedQueues === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-blockedQueues`,
      JSON.stringify(Array.from(blockedQueues))
    );
  }, [blockedQueues, updateLocal]);

  useEffect(() => {
    if (blockedDepartments === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-blockedDepartments`,
      JSON.stringify(Array.from(blockedDepartments))
    );
  }, [blockedDepartments, updateLocal]);

  useEffect(() => {
    if (blockedLocations === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-blockedLocations`,
      JSON.stringify(Array.from(blockedLocations))
    );
  }, [blockedLocations, updateLocal]);

  useEffect(() => {
    if (blockedFacilities === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-blockedFacilities`,
      JSON.stringify(Array.from(blockedFacilities))
    );
  }, [blockedFacilities, updateLocal]);

  useEffect(() => {
    if (userDisplay === undefined) {
      return;
    }

    updateLocal(`queue-summary-${id}-user-display`, userDisplay);
  }, [userDisplay, id, updateLocal]);

  useEffect(() => {
    if (userSortField === undefined) {
      return;
    }

    updateLocal(`queue-summary-${id}-user-sort-field`, userSortField);
  }, [userSortField, id, updateLocal]);

  useEffect(() => {
    if (userSortDirection === undefined) {
      return;
    }

    updateLocal(`queue-summary-${id}-user-sort-direction`, userSortDirection);
  }, [userSortDirection, id, updateLocal]);

  useEffect(() => {
    if (queueDisplay === undefined) {
      return;
    }

    updateLocal(`queue-summary-${id}-queue-display`, queueDisplay);
  }, [queueDisplay, id, updateLocal]);

  useEffect(() => {
    if (queueSortField === undefined) {
      return;
    }

    updateLocal(`queue-summary-${id}-queue-sort-field`, queueSortField);
  }, [queueSortField, id, updateLocal]);

  useEffect(() => {
    if (queueSortDirection === undefined) {
      return;
    }

    updateLocal(`queue-summary-${id}-queue-sort-direction`, queueSortDirection);
  }, [queueSortDirection, id, updateLocal]);

  useEffect(() => {
    if (departmentSortDirection === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-department-sort-direction`,
      departmentSortDirection
    );
  }, [departmentSortDirection, id, updateLocal]);

  useEffect(() => {
    if (locationSortDirection === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-location-sort-direction`,
      locationSortDirection
    );
  }, [locationSortDirection, id, updateLocal]);

  useEffect(() => {
    if (facilitySortDirection === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-facility-sort-direction`,
      facilitySortDirection
    );
  }, [facilitySortDirection, id, updateLocal]);

  useEffect(() => {
    if (userDisplay === undefined) {
      return;
    }

    setUserFormat(() => (user: any) => {
      const order = userDisplay.split("-");

      return order.reduce((sum, key, i) => {
        if (key === "last") {
          return `${sum === "" ? "" : `${sum} `}${user.lastName || ""}${order[i + 1] && order[i + 1] === "first" ? "," : ""
            }`;
        }

        if (key === "first") {
          return `${sum === "" ? "" : `${sum} `}${user.firstName || ""}`;
        }

        if (key === "ext") {
          return `${sum === "" ? "" : `${sum} `}(${user.extensionNumber || ""
            })`;
        }

        return sum;
      }, "");
    });
  }, [userDisplay]);

  useEffect(() => {
    if (queueDisplay === undefined) {
      return;
    }

    setQueueFormatSidebar(() => (queue: any) => {
      if (queueDisplay === "name-ext") {
        return `${queue.name || ""} (${queue.extensionNumber || ""})`;
      }

      if (queueDisplay === "ext-name") {
        return `(${queue.extensionNumber || ""}) ${queue.name || ""}`;
      }

      return "";
    });
  }, [queueDisplay]);

  function calculatePresence(user: any) {
    if (user.lastDndStatus === "DoNotAcceptAnyCalls") {
      return "Do Not Disturb";
    }

    if (user.lastPresenceStatus === "Offline") {
      return "Invisible";
    }
    return user.lastPresenceStatus || "Available";
  }

  // Could be improved
  // Sort logic can almost always be improved.
  useEffect(() => {
    setUserSort(() => (a: any, b: any) => {
      if (a?.emergency && !b?.emergency) {
        return userSortDirection === "asc" ? -1 : 1;
      }
      if (b?.emergency && !a?.emergency) {
        return userSortDirection === "asc" ? 1 : -1;
      }
      if (userSortField === "presence") {
        const aPresence = calculatePresence(a);
        const bPresence = calculatePresence(b);

        if (aPresence > bPresence) {
          return userSortDirection === "asc" ? 1 : -1;
        }

        if (aPresence < bPresence) {
          return userSortDirection === "asc" ? -1 : 1;
        }
      }

      if (userSortField === "department") {
        if ((a.department || "") > (b.department || "")) {
          return userSortDirection === "asc" ? 1 : -1;
        }

        if ((a.department || "") < (b.department || "")) {
          return userSortDirection === "asc" ? -1 : 1;
        }
      }

      if (userSortField === "firstName") {
        if ((a.firstName || "") > (b.firstName || "")) {
          return userSortDirection === "asc" ? 1 : -1;
        }

        if ((a.firstName || "") < (b.firstName || "")) {
          return userSortDirection === "asc" ? -1 : 1;
        }
      }

      if (userSortField === "lastName") {
        if ((a.lastName || "") > (b.lastName || "")) {
          return userSortDirection === "asc" ? 1 : -1;
        }

        if ((a.lastName || "") < (b.lastName || "")) {
          return userSortDirection === "asc" ? -1 : 1;
        }
      }

      if (userSortField === "message") {
        if ((a.message || "") > (b.message || "")) {
          return userSortDirection === "asc" ? 1 : -1;
        }

        if ((a.message || "") < (b.message || "")) {
          return userSortDirection === "asc" ? -1 : 1;
        }
      }

      if (userSortField === "elapsed-time") {
        if ((a.messageTimestamp || "") > (b.messageTimestamp || "")) {
          return userSortDirection === "asc" ? -1 : 1;
        }
        if ((a.messageTimestamp || "") < (b.messageTimestamp || "")) {
          return userSortDirection === "asc" ? 1 : -1;
        }
      }
      if (userSortField === 'queuePresence') {
        const statusPriority: Record<string, number> = {
            TakeAllCalls: 1,
            DoNotAcceptDepartmentCalls: 2,
            DoNotAcceptAnyCalls: 3,
            undefined: 4,
            "": 4,
        };
        const displayPriority = (display: string | undefined): number => {
            if (display?.startsWith("AVL")) return 1
            if (display?.startsWith("BSY")) return 2
            if (display?.startsWith("DND")) return 3
            if (display?.startsWith("INV")) return 4
            if (display === "" || display === undefined) return 5
            return 6
        }
        const statusDiff = (statusPriority[a.lastDndStatus] || 4) - (statusPriority[b.lastDndStatus] || 4);
            if (statusDiff !== 0) return statusDiff * (userSortDirection === 'asc' ? 1 : -1);

            if (a.lastPresenceStatus === b.lastPresenceStatus) {
                return (displayPriority(a.display) - displayPriority(b.display)) * (userSortDirection === 'asc' ? 1 : -1);
            } }
      if (userSortDirection === "asc") {
        return (
          parseInt(a.extensionNumber, 10) - parseInt(b.extensionNumber, 10)
        );
      }

      return parseInt(b.extensionNumber, 10) - parseInt(a.extensionNumber, 10);
    });
  }, [userSortDirection, userSortField]);

  // Could be improved
  // Sort logic can almost always be improved
  useEffect(() => {
    setQueueSort(() => (a: any, b: any) => {
      if (queueSortField === "name") {
        if ((a.name || "") > (b.name || "")) {
          return queueSortDirection === "asc" ? 1 : -1;
        }

        if ((a.name || "") < (b.name || "")) {
          return queueSortDirection === "asc" ? -1 : 1;
        }
      }

      if (queueSortField === "waiting") {
        if ((a.waiting?.size || 0) !== (b.waiting?.size || 0)) {
          if (queueSortDirection === "asc") {
            return (a.waiting?.size || 0) - (b.waiting?.size || 0);
          }

          return (b.waiting?.size || 0) - (a.waiting?.size || 0);
        }
      }

      if (queueSortField === "longestRinging") {
        const aRingTime = (
          Array.from(a.ringTimes?.values() || []) as Array<string>
        ).reduce((sum: string | undefined, time: string) => {
          if (sum === undefined || sum > time) {
            return time;
          }

          return sum;
        }, undefined);

        const bRingTime = (
          Array.from(b.ringTimes?.values() || []) as Array<string>
        ).reduce((sum: string | undefined, time: string) => {
          if (sum === undefined || sum > time) {
            return time;
          }

          return sum;
        }, undefined);

        if ((aRingTime || "") > (bRingTime || "")) {
          return queueSortDirection === "asc" ? 1 : -1;
        }

        if ((aRingTime || "") < (bRingTime || "")) {
          return queueSortDirection === "asc" ? -1 : 1;
        }
      }

      if (queueSortField === "agentsAvailable") {
        const aAgents = a.users?.filter(
          (user: {
            id: string;
            acceptCurrentQueueCalls: boolean;
            acceptQueueCalls?: boolean;
          }) => user.acceptQueueCalls && user.acceptCurrentQueueCalls
        ).length;

        const bAgents = b.users?.filter(
          (user: {
            id: string;
            acceptCurrentQueueCalls: boolean;
            acceptQueueCalls?: boolean;
          }) => user.acceptQueueCalls && user.acceptCurrentQueueCalls
        ).length;

        if ((aAgents || 0) !== (bAgents || 0)) {
          if (queueSortDirection === "asc") {
            return (aAgents || 0) - (bAgents || 0);
          }

          return (bAgents || 0) - (aAgents || 0);
        }
      }

      // extension
      if (queueSortDirection === "asc") {
        return (
          parseInt(a.extensionNumber, 10) - parseInt(b.extensionNumber, 10)
        );
      }

      return parseInt(b.extensionNumber, 10) - parseInt(a.extensionNumber, 10);
    });
  }, [queueSortDirection, queueSortField]);


  useEffect(() => {
    setAirSort(() => (a: any, b: any) => {
     if (airSortField === "name") {
      if ((a.name || "") > (b.name || "")) {
        return airSortDirection === "asc" ? 1 : -1;
      }

      if ((a.name || "") < (b.name || "")) {
        return airSortDirection === "asc" ? -1 : 1;
      }
     } else {
      if ((a.extensionNumber || "") > (b.extensionNumber || "")) {
        return airSortDirection === "asc" ? 1 : -1;
      }

      if ((a.extensionNumber || "") < (b.extensionNumber || "")) {
        return airSortDirection === "asc" ? -1 : 1;
      }
     }
      return 0;
    });
  }, [airSortDirection, airSortField]);


    useEffect(() => {
    setIvrSort(() => (a: any, b: any) => {
      if (ivrSortField === "name") {
        if ((a.name || "") > (b.name || "")) {
          return ivrSortDirection === "asc" ? 1 : -1;
        }
  
        if ((a.name || "") < (b.name || "")) {
          return ivrSortDirection === "asc" ? -1 : 1;
        }
       }
       if (ivrSortField === "extensionNumber") {
        if ((a.extensionNumber || "") > (b.extensionNumber || "")) {
          return ivrSortDirection === "asc" ? 1 : -1;
        }
  
        if ((a.extensionNumber || "") < (b.extensionNumber || "")) {
          return ivrSortDirection === "asc" ? -1 : 1;
        }
       }
        return 0;
    });
  }, [ivrSortDirection, ivrSortField]);

  useEffect(() => {
    setDepartmentSort(() => (a: any, b: any) => {
      if ((a.name || "") > (b.name || "")) {
        return departmentSortDirection === "asc" ? 1 : -1;
      }

      if ((a.name || "") < (b.name || "")) {
        return departmentSortDirection === "asc" ? -1 : 1;
      }

      return 0;
    });
  }, [departmentSortDirection]);

  useEffect(() => {
    setLocationSort(() => (a: any, b: any) => {
      if ((a.name || "") > (b.name || "")) {
        return locationSortDirection === "asc" ? 1 : -1;
      }

      if ((a.name || "") < (b.name || "")) {
        return locationSortDirection === "asc" ? -1 : 1;
      }

      return 0;
    });
  }, [locationSortDirection]);

  useEffect(() => {
    setFacilitySort(() => (a: any, b: any) => {
      if ((a || "") > (b || "")) {
        return facilitySortDirection === "asc" ? 1 : -1;
      }

      if ((a || "") < (b || "")) {
        return facilitySortDirection === "asc" ? -1 : 1;
      }

      return 0;
    });
  }, [facilitySortDirection]);

  useEffect(() => {
    if (mode === "light") {
      setBackgroundColor("#0684bd");
      return;
    }

    setBackgroundColor("#181818");
  }, [mode]);

  useEffect(() => {
    setExcludedUsers(
      new Set(JSON.parse(local[`queue-summary-${id}-excludedUsers`] || "[]"))
    );
    setBlocked(
      new Set(JSON.parse(local[`queue-summary-${id}-blocked`] || "[]"))
    );
    setBlockedQueues(
      new Set(JSON.parse(local[`queue-summary-${id}-blockedQueues`] || "[]"))
    );
    setBlockedDepartments(
      new Set(
        JSON.parse(local[`queue-summary-${id}-blockedDepartments`] || "[]")
      )
    );
    setBlockedLocations(
      new Set(JSON.parse(local[`queue-summary-${id}-blockedLocations`] || "[]"))
    );
    setBlockedFacilities(
      new Set(JSON.parse(local[`queue-summary-${id}-blockedFacilities`] || "[]"))
    );
    setExcluded(
      new Set(JSON.parse(local[`queue-summary-${id}-excluded`] || "[]"))
    );
    setExcludedDepartments(
      new Set(
        JSON.parse(local[`queue-summary-${id}-excludedDepartments`] || "[]")
      )
    );
    setExcludedLocations(
      new Set(
        JSON.parse(local[`queue-summary-${id}-excludedLocations`] || "[]")
      )
    );
    setExcludedFacilities(
      new Set(
        JSON.parse(local[`queue-summary-${id}-excludedFacilities`] || "[]")
      )
    );
    setChecked(
      new Set(JSON.parse(local[`queue-summary-${id}-checked`] || "[]"))
    );
    setUserDisplay(
      local[`queue-summary-${id}-user-display`] || "last-first-ext"
    );
    setUserSortField(
      local[`queue-summary-${id}-user-sort-field`] || "extensionNumber"
    );
    setUserSortDirection(
      local[`queue-summary-${id}-user-sort-direction`] || "asc"
    );
    setQueueDisplay(local[`queue-summary-${id}-queue-display`] || "name-ext");
    setQueueSortField(
      local[`queue-summary-${id}-queue-sort-field`] || "extensionNumber"
    );
    setQueueSortDirection(
      local[`queue-summary-${id}-queue-sort-direction`] || "asc"
    );
    setDepartmentSortDirection(
      local[`queue-summary-${id}-department-sort-direction`] || "asc"
    );
    setLocationSortDirection(
      local[`queue-summary-${id}-location-sort-direction`] || "asc"
    );
    setFacilitySortDirection(
      local[`queue-summary-${id}-facility-sort-direction`] || "asc"
    );
    setShowPortraits(
      (local[`queue-summary-${id}-show-portraits`] || "true") === "true"
    );
  }, [id]);

  useEffect(() => {
    if (showPortraits === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-show-portraits`,
      showPortraits ? "true" : "false"
    );
  }, [showPortraits, id, updateLocal]);

  useEffect(() => {
    if (excluded === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-excluded`,
      JSON.stringify(Array.from(excluded))
    );
  }, [excluded, id, updateLocal]);

  useEffect(() => {
    if (excludedDepartments === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-excludedDepartments`,
      JSON.stringify(Array.from(excludedDepartments))
    );
  }, [excludedDepartments, id, updateLocal]);

  useEffect(() => {
    if (checked === undefined) {
      return;
    }

    updateLocal(
      `queue-summary-${id}-checked`,
      JSON.stringify(Array.from(checked))
    );
  }, [checked, id, updateLocal]);

  useEffect(() => {
   if (id) {
    let sortFieldFromStorage = localStorage.getItem(`sort-field-${rcId}`);
    if (!sortFieldFromStorage) {
      sortFieldFromStorage = 'extensionNumber'
    }
    setUserSortField(sortFieldFromStorage)
   }
  }, [id])



  // Could be improved
  useEffect(() => {
    const data = historicals[0];
    if (data !== undefined) {
      // data.event.forEach(userCallEventHandler);

      data.queue.forEach((myQueue) => {
        queues.set(myQueue.id, myQueue);
      });

      data.user.forEach((myUser) => {
        const unprocessedUsers = unprocessed.get(myUser.id);

        users.set(myUser.id, {
          ...myUser,
        });
      });

      unprocessed.clear();

      const filteredUsers = filterUsers();

      setWidgetData(() => {
        const newWidgetData = [] as Array<{
          id: string;
          firstName: string;
          lastName: string;
          extensionNumber: string;
          department: string;
          location: string;
          uri: string;
          messageTimestamp?: number;
          status: string;
          glipStatus: string;
          type: string;
          lastPresenceStatus: string;
          lastDndStatus: string;
          display?: string;
          emergency: boolean;
          queues?: Array<{
            queueId: string;
            name: string;
            acceptCurrentQueueCalls?: boolean;
          }>;
          late: boolean | undefined;
          timerInfo?: any;
        }>;

        filteredUsers.forEach((myUser) => {
          newWidgetData.push({
            id: myUser.id,
            firstName: myUser.firstName || "",
            lastName: myUser.lastName || "",
            extensionNumber: myUser.extensionNumber || "",
            department: myUser.department || "{Not defined}",
            location: myUser.site?.name || "{default}",
            uri: myUser.uri || "./default-user-image.ico",
            messageTimestamp: myUser.messageTimestamp
              ? new Date(myUser.messageTimestamp).getTime()
              : undefined,
            status: myUser.status || "",
            glipStatus: myUser.glipStatus || "",
            type: myUser.type || "",
            lastPresenceStatus: myUser.lastPresenceStatus || "",
            lastDndStatus: myUser.lastDndStatus || "",
            display: myUser.display,
            emergency: myUser.emergency || false,
            queues: myUser.queues,
            late: myUser.late || undefined,
            timerInfo: myUser.timerInfo || undefined,
          });
        });

        if (userSort) {
          return newWidgetData.sort(userSort);
        }
        return newWidgetData;
      });
    }
  }, [historicals, userSort, filterUsers]);


  useEffect(() => {
    if (!presenceEvents || presenceEvents.length === 0) {
      return;
    }

    presenceEvents.forEach((record) => {
      const userId = record.id;
      let existingUser = users.get(userId);

      if (existingUser === undefined) {
        existingUser = unprocessed.get(userId) || {
          id: userId,
          // calls: new Map<string, Call>(),
        };
      }

      const updatedUser = {
        firstName: "",
        lastName: "",
        extensionNumber: "",
        department: "",
        status: "",
        lastPresenceStatus: "",
        ...existingUser,
        ...record,
      };

      if (users.get(userId) === undefined) {
        unprocessed.set(userId, {
          ...updatedUser,
        });
      } else {
        users.set(userId, { ...updatedUser });
      }
    });

    // Filter and update widget data after processing all events
    const filteredUsers = filterUsers();

    setWidgetData((oldWidgetData) => {
      if (oldWidgetData === undefined) {
        return undefined;
      }

      unprocessed.clear();

      const newWidgetData = filteredUsers.map((myUser) => ({
        id: myUser.id,
        firstName: myUser.firstName || "",
        lastName: myUser.lastName || "",
        extensionNumber: myUser.extensionNumber || "",
        department: myUser.department || "{Not defined}",
        location: myUser.site?.name || "{default}",
        uri: myUser.uri || "./default-user-image.ico",
        messageTimestamp: myUser.messageTimestamp
          ? new Date(myUser.messageTimestamp).getTime()
          : undefined,
        status: myUser.status || "",
        glipStatus: myUser.glipStatus || "",
        type: myUser.type || "",
        lastPresenceStatus: myUser.lastPresenceStatus || "",
        lastDndStatus: myUser.lastDndStatus || "",
        display: myUser.display,
        emergency: myUser.emergency || false,
        queues: myUser.queues,
        late: myUser.late || undefined,
        timerInfo: myUser.timerInfo || undefined
        // Uncomment and map calls if needed:
        // calls: myUser.calls
        //   ? Array.from(myUser.calls.values()).map((call) => ({
        //       id: call.id,
        //       toName: call.toName,
        //       toNumber: call.toNumber,
        //       fromName: call.fromName,
        //       fromNumber: call.fromNumber,
        //       outbound: call.outbound,
        //       inbound: call.inbound,
        //       duration: call.startTime
        //         ? new Date().getTime() +
        //           offset -
        //           new Date(call.startTime).getTime()
        //         : undefined,
        //     }))
        //   : [],
      }));

      if (userSort) {
        return newWidgetData.sort(userSort);
      }

      return newWidgetData;
    });
  }, [presenceEvents, userSort, filterUsers]);


  // Could be improved
  // This code seems to read the presence events and apply them.
  useEffect(() => {
    const record = queuePresenceEvents[0];
    if (record === undefined) {
      return;
    }

    const queue = queues.get(record.id);
    if (queue === undefined) {
      return;
    }

    const i = queue.users.findIndex((userObj) => userObj.id === record.userId);
    if (i === -1) {
      return;
    }

    queue.users.splice(i, 1, {
      id: record.userId,
      acceptCurrentQueueCalls: record.acceptCurrentQueueCalls,
    });

    queues.set(record.id, queue);

    setWidgetData((oldWidgetData) =>
      oldWidgetData?.map((row) => {
        if (row.id === record.userId) {
          const userQueues = row.queues;
          if (userQueues !== undefined) {
            const changedQueue = userQueues.find(
              (myQueue) => myQueue.queueId === record.id
            );
            if (changedQueue !== undefined) {
              changedQueue.acceptCurrentQueueCalls =
                record.acceptCurrentQueueCalls;
              return {
                ...row,
                queues: userQueues,
              };
            }
          }
        }

        return {
          ...row,
        };
      })
    );
  }, [queuePresenceEvents, userSort, filterUsers]);

  useEffect(() => {
    if (userSort === undefined) {
      return;
    }

    setWidgetData((oldWidgetData) => {
      if (oldWidgetData === undefined) {
        return undefined;
      }

      return oldWidgetData.sort(userSort);
    });
  }, [userSort]);

  useEffect(() => {
    const filteredUsers = filterUsers();

    setWidgetData((oldWidgetData) => {
      if (oldWidgetData === undefined) {
        return undefined;
      }
      unprocessed.clear();

      const newWidgetData = [] as Array<{
        id: string;
        firstName: string;
        lastName: string;
        extensionNumber: string;
        department: string;
        location: string;
        uri: string;
        messageTimestamp?: number;
        status: string;
        glipStatus: string;
        type: string;
        lastPresenceStatus: string;
        lastDndStatus: string;
        emergency: boolean;
        display?: string;
        queues?: Array<{
          queueId: string;
          name: string;
          acceptCurrentQueueCalls?: boolean;
        }>;
        late?: boolean | undefined;
        timerInfo?: any;
      }>;

              filteredUsers.forEach((myUser) => {
          newWidgetData.push({
            id: myUser.id,
            firstName: myUser.firstName || "",
            lastName: myUser.lastName || "",
            extensionNumber: myUser.extensionNumber || "",
            department: myUser.department || "{Not defined}",
            location: myUser.site?.name || "{default}",
            uri: myUser.uri || "./default-user-image.ico",
            messageTimestamp: myUser.messageTimestamp
              ? new Date(myUser.messageTimestamp).getTime()
              : undefined,
            status: myUser.status || "",
            glipStatus: myUser.glipStatus || "",
            type: myUser.type || "",
            lastPresenceStatus: myUser.lastPresenceStatus || "",
            lastDndStatus: myUser.lastDndStatus || "",
            display: myUser.display,
            queues: myUser.queues,
            emergency: myUser.emergency || false,
            late: myUser.late || undefined,
            timerInfo: myUser.timerInfo || undefined,
          });
        });

      if (userSort) {
        return newWidgetData.sort(userSort);
      }
      return newWidgetData;
    });
  }, [
    checked,
    excluded,
    showAvailable,
    showBusy,
    showDnd,
    showInvisible,
    tab,
    blockedQueues,
    excludedUsers,
    filterUsers,
    userSort,
  ]);

  // what shoud happen when user is admin and click on the user widget
  const adminClick = (theId: string) => {
    console.log(theId);
    setProfileId(theId);
  };

  const clickOnMessage = (extensionNumber: string) => {
    const dialerRef = (document.querySelector("#ex-dialer") as HTMLIFrameElement)
    if (dialerRef) {
      dialerRef.contentWindow!.postMessage({
          type: "rc-adapter-new-sms",
          phoneNumber: extensionNumber,
          conversation: true,
      }, "*");
      setDialer(true)
    }
  };
  const clickOnPhone = (extensionNumber: string) => {
    const dialerRef = (document.querySelector("#ex-dialer") as HTMLIFrameElement)
    if (dialerRef) {
      dialerRef.contentWindow!.postMessage({
          type: "rc-adapter-new-call",
          phoneNumber: extensionNumber,
          toCall: true,
      }, "*");
      setDialer(true)
    }
  };

  const clickOnHand = useCallback(
    async (userId: string, handRaised: boolean, late: boolean) => {
      if (
        userId !== undefined &&
        organizationId !== undefined &&
        handRaised !== undefined &&
        (isAdmin || userId === rcId)
      ) {
        const response = await fetch(apiUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: `/restapi/v1.0/account/${organizationId}/extension/${userId}/presence`,
            body: {
              emergency: !handRaised,
              late,
            },
          }),
        });
      }
    },
    [rcId, organizationId, apiUrl]
  );

  const classes = legacyUI ? useStyles() : useNewStyles();

  if (isVisible) {
    document.body.className = classes.body;
  }
  const handleQueueCompactView = useCallback((t: boolean) => {
    setQueueCompactView((prev: boolean) => {
      localStorage.setItem(`queue-compact-view-${rcId}`, JSON.stringify(t))
      return t;
    })
  }, [queueCompactView])

  useEffect(() => {
  if (excludedUsers && excludedUsers.size) { 
    localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(excludedUsers)))
  }
  }, [excludedUsers, id])

  useEffect(() => {
    if (excluded && excluded.size) {
      localStorage.setItem(`excluded-queues-${rcId}`, JSON.stringify(Array.from(excluded)))
    }
  }, [excluded, id])

  useEffect(() => {
    if (excludedDepartments && excludedDepartments.size) {
      localStorage.setItem(`excluded-departments-${rcId}`, JSON.stringify(Array.from(excludedDepartments)))
    }
  }, [excludedDepartments, id])

  useEffect(() => {
    if (excludedFacilities && excludedFacilities.size) {
      localStorage.setItem(`excluded-sites-${rcId}`, JSON.stringify(Array.from(excludedFacilities)))
    }
  }, [excludedFacilities, id])

  useEffect(() => {
    if (excludedLocations && excludedLocations.size) {
      localStorage.setItem(`excluded-locations-${rcId}`, JSON.stringify(Array.from(excludedLocations)))
    }
  }, [excludedLocations, id])

  useEffect(() => {
    if (userSortField) {
      localStorage.setItem(`user-sort-field-${rcId}`, userSortField)
    }
  }, [userSortField, id])

  useEffect(() => {
    if (userSortDirection) localStorage.setItem(`user-sort-direction-${rcId}`, userSortDirection)
  }, [userSortDirection, id])

  useEffect(() => {
    if (showPortraits) localStorage.setItem(`show-user-portraits-${rcId}`, JSON.stringify(showPortraits))
  }, [showPortraits, id])

  useEffect(() => {
    if (queueDisplay) localStorage.setItem(`queue-display-${rcId}`, queueDisplay)
  }, [queueDisplay, id])

  useEffect(() => {
    if (queueSortField) localStorage.setItem(`queue-sort-field-${rcId}`, queueSortField)
  }, [queueSortField, id])
  useEffect(() => {
    if (queueSortDirection) localStorage.setItem(`queue-sort-direction-${rcId}`, queueSortDirection)
  }, [queueSortDirection, id])


  useEffect(() => {
    const usersFromStorage = localStorage.getItem(`excluded-users-${rcId}`) || "[]"
    const queuesFromStorage = localStorage.getItem(`excluded-queues-${rcId}`) || "[]"
    const departmentsFromStorage = localStorage.getItem(`excluded-departments-${rcId}`) || "[]"
    const sitesFromStorage = localStorage.getItem(`excluded-sites-${rcId}`) || "[]"
    const locationsFromStorage = localStorage.getItem(`excluded-locations-${rcId}`) || "[]"
    const userSortFieldFromStorage = localStorage.getItem(`user-sort-field-${rcId}`) || "extensionNumber"
    const userSortDirectionFromStorage = localStorage.getItem(`user-sort-direction-${rcId}`) || "asc"
    const showUserPortraitsFromStorage = localStorage.getItem(`show-user-portraits-${rcId}`) || 'true';
    const queueDisplayFromStorage = localStorage.getItem(`queue-display-${rcId}`) || "name-ext";
    const queueSortFieldFromStorage = localStorage.getItem(`queue-sort-field-${rcId}`) || "extensionNumber";
    const queueSortDirectionFromStorage = localStorage.getItem(`queue-sort-direction-${rcId}`) || "asc";
    const queueCompactViewFromStorage = localStorage.getItem(`queue-compact-view-${rcId}`) || "false"
    const queueCompactWidgetMetricsFromStorage = localStorage.getItem(`queue-compact-metrics-${rcId}`);
    const userDisplayFromStorage = localStorage.getItem(`user-display-${rcId}`) ||  "last-first-ext";
    const showPortraitsFromStorage = localStorage.getItem(`show-portraits-${rcId}`) || "true";
    const availableStorage = localStorage.getItem(`available-checkbox-${rcId}`)
    const busyStorage = localStorage.getItem(`busy-checkbox-${rcId}`)
    const dndStorage = localStorage.getItem(`dnd-checkbox-${rcId}`)
    const invStorage = localStorage.getItem(`inv-checkbox-${rcId}`)

    const parsedUsers = JSON.parse(usersFromStorage)
    const parsedQueues = JSON.parse(queuesFromStorage)
    const parsedDepartments = JSON.parse(departmentsFromStorage)
    const parsedSites = JSON.parse(sitesFromStorage)
    const parsedLocations = JSON.parse(locationsFromStorage)
    const parsedUserSortField = userSortFieldFromStorage
    const parsedUserSortDirection = userSortDirectionFromStorage;
    const parsedShowUserPortraits = JSON.parse(showUserPortraitsFromStorage)
    const parsedQueueDisplay = queueDisplayFromStorage;
    const parsedQueueSortDirection = queueSortDirectionFromStorage;
    const parsedQueueSortField = queueSortFieldFromStorage;
    const parsedQueueCompactView = JSON.parse(queueCompactViewFromStorage)
    const parsedQueueCompactWidgetMetrics = queueCompactWidgetMetricsFromStorage
    ? JSON.parse(queueCompactWidgetMetricsFromStorage)
    : defaultWidgetMetrics;
    const parsedUserDisplay = userDisplayFromStorage;
    const parsedShowPortraits = JSON.parse(showPortraitsFromStorage);

    
    if (parsedUsers && parsedUsers.length) setExcludedUsers(new Set(parsedUsers));
    if (parsedQueues && parsedQueues.length) setExcluded(new Set(parsedQueues));
    if (parsedDepartments && parsedDepartments.length) setExcludedDepartments(new Set(parsedDepartments));
    if (parsedSites && parsedSites.length) setExcludedFacilities(new Set(parsedSites));
    if (parsedLocations && parsedLocations.length) setExcludedLocations(new Set(parsedLocations));
    if (parsedUserSortField) setUserSortField(parsedUserSortField);
    if (parsedUserSortDirection) setUserSortDirection(parsedUserSortDirection);
    if (parsedQueueDisplay) setQueueDisplay(parsedQueueDisplay);
    if (parsedQueueSortDirection) setQueueSortDirection(parsedQueueSortDirection);
    if (parsedQueueSortField) setQueueSortField(parsedQueueSortField);
    if (parsedQueueCompactView) setQueueCompactView(parsedQueueCompactView);
    if (parsedQueueCompactWidgetMetrics) setCompactWidgetMetrics(Array.from(parsedQueueCompactWidgetMetrics))
    if (parsedShowPortraits) setShowPortraits(parsedShowPortraits)
    if (parsedUserDisplay) setUserDisplay(parsedUserDisplay)

      // fetch presence checkbox configurations from localStorage.
    if (availableStorage) setShowAvailable(JSON.parse(availableStorage))
    if (busyStorage) setShowBusy(JSON.parse(busyStorage))
    if (dndStorage) setShowDnd(JSON.parse(dndStorage))
    if (invStorage) setShowInvisible(JSON.parse(invStorage))
    if (!availableStorage) localStorage.setItem(`available-checkbox-${rcId}`, "true")
    if (!busyStorage) localStorage.setItem(`busy-checkbox-${rcId}`, "true")
    if (!dndStorage) localStorage.setItem(`dnd-checkbox-${rcId}`, "true")
    if (!invStorage) localStorage.setItem(`inv-checkbox-${rcId}`, "true")

  }, [id])

  const handleCompactQueueMetrics = useCallback((widget, key, bool) => {
    setCompactWidgetMetrics((prev) => {
        const prevMetrics = Array.isArray(prev) ? [...prev] : [];
        const index = prevMetrics.findIndex((item) => item.key === key);
        if (index !== -1) {
             prevMetrics[index] = { 
                ...prevMetrics[index], 
                visible: bool
            };
        } else {
             prevMetrics.push(widget);
        }
        localStorage.setItem(`queue-compact-metrics-${rcId}`, JSON.stringify(prevMetrics));
        return prevMetrics;
    });
}, [compactWidgetMetrics]);


useEffect(() => {
  if (rcId) {
    const queueCompactList = localStorage.getItem(`queue-compact-metrics-${rcId}`)
    if (queueCompactList) {
      setCompactWidgetMetrics(JSON.parse(queueCompactList))
    }
    if (!queueCompactList) {
      setCompactWidgetMetrics([
        { key: 'available-agents', label: 'Available Agents', visible: false },
        { key: 'busy-agents', label: 'Busy Agents', visible: false  },
        { key: 'unavailable-agents', label: 'Unavailable Agents', visible: false  },
        { key: 'agent-count', label: 'Total Agents', visible: false  },
        { key: 'waiting-count', label: 'Waiting Calls', visible: false  },
        { key: 'longest-waiting', label: 'Longest Waiting' , visible: false },
        { key: 'answered-count', label: 'Answered Calls', visible: false },
        { key: 'answered-pct', label: 'Answered %', visible: false  },
        { key: 'abandoned-count', label: 'Abandoned Calls', visible: false },
        { key: 'abandoned-pct', label: 'Abandoned %', visible: false  },
        { key: 'voicemail-count', label: 'Voicemail Calls', visible: false },
        { key: 'voicemail-pct', label: 'Voicemail %', visible: false  },
        { key: 'other-count', label: 'Other Calls', visible: false },
        { key: 'other-pct', label: 'Other %', visible: false  },
        { key: 'call-count', label: 'Total Calls', visible: false  },
      ])
    }
  }
}, [rcId])

  const handleDragEnd = (result: any) => {
    const items = Array.from(compactWidgetMetrics!)
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)
    localStorage.setItem(`queue-compact-metrics-${rcId}`, JSON.stringify(items));
    setCompactWidgetMetrics(items)
  }

  const lightMode = mode === "light";

  return ( 
    <> 
      {sidebar &&
        excluded &&
        excludedUsers &&
        excludedDepartments &&
        excludedLocations &&
        blocked &&
        blockedQueues &&
        blockedDepartments &&
        blockedLocations && (
          <List
            id="hud-sidebar"
            aria-labelledby="sidebar-list"
            className={classes.sidebarPanel}
            style={{
              float: "right",
              backgroundColor,
              marginTop: legacyUI ? 145 : 110,
              borderRadius: "5px",
            }}
          >
            {
              tab !== "air" && tab !== "ivr" && (
                <>
                {/* user filters */}
                {
                  !legacyUI && (
                    <>
                      <ListItem
                        role="listitem"
                        aria-label="Open user filters"
                        aria-hidden={false}
                        button
                        onClick={() => {
                          setOpen((oldOpen) => (oldOpen === "userFilters" ? "" : "userFilters"));
                        }}>
                        <ListItemText primary="Presence Filters" />
                        {showAvailable && showBusy && showDnd && showInvisible ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
                        {open === "userFilters" ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Collapse in={open === "userFilters"} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding> 
                        <div className={newUi.checkboxContainer} style={{background: lightMode ? "#378ccd" :  "#242424"}}>
                          <div className={newUi.sidebarFormRowCheckbox}>
                            <Checkbox
                              id="available-checkbox"
                              color="default"
                              checked={showAvailable}
                              onClick={() => {
                                localStorage.setItem(`available-checkbox-${rcId}`, JSON.stringify(!showAvailable))
                                setShowAvailable((p: any) => !p)}}
                              style={{ color: "white", width: 20, height: 20 }} /> 
                            <label htmlFor="available-checkbox" className={newUi.sidebarOptionLabel}>Available</label>
                          </div>
                          <div className={newUi.sidebarFormRowCheckbox}>
                            <Checkbox 
                              id="busy-checkbox"
                              color="default"
                              checked={showBusy}
                              onClick={() => {
                                localStorage.setItem(`busy-checkbox-${rcId}`, JSON.stringify(!showBusy))
                                setShowBusy((p: any) => !p)}}
                              style={{ color: "white", width: 20, height: 20 }}/> 
                            <label htmlFor="busy-checkbox" className={newUi.sidebarOptionLabel}>Busy</label>
                          </div>
                          <div className={newUi.sidebarFormRowCheckbox}>
                            <Checkbox 
                            id="dnd-checkbox"
                             color="default"
                             checked={showDnd}
                              onClick={() => {
                                localStorage.setItem(`dnd-checkbox-${rcId}`, JSON.stringify(!showDnd))
                                setShowDnd((p: any) => !p)}}
                             style={{ color: "white", width: 20, height: 20 }}/> 
                            <label htmlFor="dnd-checkbox" className={newUi.sidebarOptionLabel}>DND</label>
                          </div>
                          <div className={newUi.sidebarFormRowCheckbox}>
                            <Checkbox
                            id="invisible-checkbox"
                             color="default"
                             checked={showInvisible}
                              onClick={() => {
                                localStorage.setItem(`inv-checkbox-${rcId}`, JSON.stringify(!showInvisible))
                                setShowInvisible((p: any) => !p)}}
                             style={{ color: "white", width: 20, height: 20 }} /> 
                            <label htmlFor="invisible-checkbox" className={newUi.sidebarOptionLabel}>Invisible</label>
                          </div>
                        </div>
                  </List> 
                  </Collapse> 
                      </>
                    )
                  }
                <ListItem
                  role="listitem"
                  aria-label="Open user filters"
                  aria-hidden={false}
                  button
                  onClick={() => {
                    setOpen((oldOpen) => (oldOpen === "users" ? "" : "users"));
                  }}
                >
              <ListItemText primary="Users" />
              {!blocked.size && !excludedUsers.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
              {open === "users" ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open === "users"} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding> 
                    {
                      !legacyUI && (
                        <>
                        {/* user filters */}
                        
                        {/* display user portraits */}
                          <div className={newUi.sidebarFormRowCheckbox}>
                            <Checkbox checked={showPortraits} onChange={() => {
                                localStorage.setItem(`show-portraits-${rcId}`, JSON.stringify(!showPortraits))
                                setShowPortraits(!showPortraits)
                              }}
                              color="default"
                              style={{ color: "white", width: 20, height: 20 }}
                            />
                            <span className={newUi.sidebarOptionLabel}>Show Portraits</span>
                          </div>
                          {/* user display format */}
                          <div className={newUi.sidebarFormRowDropdown}>
                            <div style={{flex: 1}}>
                              <span className={newUi.sidebarOptionLabel}>Display</span>
                              <select className={lightMode ? newUi.sidebarDropdown : newUi.sidebarDropdownDark} id="user-display-label" value={userDisplay} onChange={(event: any) => {
                                localStorage.setItem(`user-display-${rcId}`, event.target.value.toString())
                                setUserDisplay(event.target.value.toString())
                              }}>
                                <option value="first-last-ext">First Last (ext)</option>
                                  <option value="last-first-ext">Last, First (ext)</option>
                                  <option value="ext-first-last">(ext) First Last</option>
                                  <option value="ext-last-first">(ext) Last, First</option>
                              </select>
                            </div>
                          </div>
                          {/* user sort field and sort direction, nested in one row */}
                          <div className={newUi.sidebarFormRowDropdown}>
                            <div style={{width: '100%'}}>
                              <span className={newUi.sidebarOptionLabel}>Sort Field</span>
                              <select className={lightMode ? newUi.sidebarDropdown : newUi.sidebarDropdownDark} id="user-sort-field" value={userSortField} 
                              onChange={(event: any) =>
                                setUserSortField(event.target.value.toString())
                              }>
                                <option value="extensionNumber">Extension</option>
                                <option value="department">Department</option>
                                <option value="firstName">First Name</option>
                                <option value="lastName">Last Name</option>
                                <option value="message">Status</option>
                                <option value="presence">Presence</option>
                                <option value="queuePresence">Queue Presence</option>
                                <option value="elapsed-time">Elapsed Time</option>
                              </select>
                            </div>
                            <div className={newUi.ascDescButtonContainer} style={{display: "flex", flex: 1, justifyContent: 'end'}}>
                              {/* user sort direction */}
                              <button onClick={() => setUserSortDirection((p) => p === "desc" ? "asc" : "desc")} className={newUi.ascDescButton} style={{...sidebarDescAscStyleHandler(lightMode), marginLeft: 10}} type="button">
                                {userSortDirection}
                                {userSortDirection === 'asc' ? <KeyboardArrowUp style={{color: lightMode? "black" :  "white"}} fontSize="small"  /> : <KeyboardArrowDown style={{color: lightMode? "black":  "white"}} fontSize="small"  />}
                              </button>
                            </div>
                          </div>
                        </>
                      )
                    }
                    {
                      legacyUI && (
                        <>
                        <ListItem>
                          <FormControl classes={{ root: mode === 'light' ? classes.formControl : classes.formControlDark }}>
                            <InputLabel
                              style={{ color: "white" }}
                              htmlFor="user-display-label"
                            >
                              Display
                            </InputLabel>
                            <NativeSelect
                              inputProps={{
                                id: "user-display-label",
                              }}
                              classes={{
                                root:
                                  mode === "dark"
                                    ? classes.selectDark
                                    : classes.select,
                                icon:
                                  mode === "dark" ? classes.iconDark : classes.icon,
                              }}
                              value={userDisplay}
                              onChange={(event: any) => {
                                localStorage.setItem(`user-display-${rcId}`, event.target.value.toString())
                                setUserDisplay(event.target.value.toString())
                              }}
                            >
                              <option value="first-last-ext">First Last (ext)</option>
                              <option value="last-first-ext">
                                Last, First (ext)
                              </option>
                              <option value="ext-first-last">(ext) First Last</option>
                              <option value="ext-last-first">
                                (ext) Last, First
                              </option>
                            </NativeSelect>
                          </FormControl>
                          <FormControl style={{ marginLeft: 10 }}>
                            <FormControlLabel
                              classes={{ label: classes.listText }}
                              control={
                                <Checkbox
                                  checked={showPortraits}
                                  onChange={() => {
                                    localStorage.setItem(`show-portraits-${rcId}`, JSON.stringify(!showPortraits))
                                    setShowPortraits(!showPortraits)
                                  }}
                                  color="default"
                                  style={{ color: "white" }}
                                />
                              }
                              label="Show Portraits"
                            />
                          </FormControl>
                        </ListItem>
                        <ListItem>
                          <FormControl>
                            <InputLabel
                              style={{ color: "white" }}
                              htmlFor="user-sort-field"
                            >
                              Sort Field
                            </InputLabel>
                            <NativeSelect
                              inputProps={{
                                id: "user-sort-field",
                              }}
                              classes={{
                                root:
                                  mode === "dark"
                                    ? classes.selectDark
                                    : classes.select,
                                icon:
                                  mode === "dark" ? classes.iconDark : classes.icon,
                              }}
                              value={userSortField}
                              onChange={(event: any) =>
                                setUserSortField(event.target.value.toString())
                              }
                            >
                              <option value="extensionNumber">Extension</option>
                              <option value="department">Department</option>
                              <option value="firstName">First Name</option>
                              <option value="lastName">Last Name</option>
                              <option value="message">Status</option>
                              <option value="presence">Presence</option>
                              <option value="queuePresence">Queue Presence</option>
                              <option value="elapsed-time">Elapsed Time</option>
                            </NativeSelect>
                          </FormControl>
                          <FormControl style={{ marginLeft: 10 }}>
                            <InputLabel
                              style={{ color: "white" }}
                              htmlFor="user-sort-direction"
                            >
                              Sort Direction
                            </InputLabel>
                            <NativeSelect
                              inputProps={{
                                id: "user-sort-direction",
                              }}
                              classes={{
                                root:
                                  mode === "dark"
                                    ? classes.selectDark
                                    : classes.select,
                                icon:
                                  mode === "dark" ? classes.iconDark : classes.icon,
                              }}
                              value={userSortDirection}
                              onChange={(event: any) =>
                                setUserSortDirection(event.target.value.toString())
                              }
                            >
                              <option value="asc">Ascending</option>
                              <option value="desc">Descending</option>
                            </NativeSelect>
                          </FormControl>
                        </ListItem>
                        </>
                      )
                    }
                    {tab === "users" && (
                      <View
                        viewType="users"
                        historical={historicalUsers}
                        legacyUI={legacyUI}
                        setSearch={setUserSearch}
                        search={userSearch}
                        mySort={userSort}
                        excluded={excludedUsers}
                        format={userFormat}
                        rcId={rcId}
                        searchFilters={[
                          "firstName",
                          "lastName",
                          "extensionNumber",
                        ]}
                        // viewList={viewList}
                        // uuid={uuid}
                        // setViewList={setViewList}
                        // setUuid={setUuid}
                        // id={id}
                        blocked={blocked}
                        setBlocked={setBlocked}
                        mode={mode}
                        onItemClick={(historicalUser: any) => {
                          setExcludedUsers((oldexcluded) => {
                            const newExcluded = new Set(oldexcluded);
                            if (newExcluded.has(historicalUser.id)) {
                              newExcluded.delete(historicalUser.id);
                            } else {
                              newExcluded.add(historicalUser.id);
                            }
                            localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(newExcluded)))
                            return newExcluded;
                          });
                        }}
                        onAll={() => {
                          setExcludedUsers(() => {
                            const exc = historicalUsers
                              .filter((historicalUser) => blocked.has(historicalUser.id))
                              .keySeq();
                              localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(exc)))

                            return new Set(exc); // Convert to a native Set
                          });
                        }}
                        onNone={() => {
                          const exc = new Set( historicalUsers.valueSeq().map((historicalUser) => historicalUser.id).toArray())
                          localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify("[]"))
                          return setExcludedUsers(exc)
                        }}
                      />
                    )}
                  </List>
                </Collapse>

                <ListItem
                  role="listitem" aria-label="Open queues filters" aria-hidden={false} button onClick={() => { setOpen((oldOpen) => (oldOpen === "queues" ? "" : "queues"));}}>
                  <ListItemText primary="Queues" />
                  {!blockedQueues.size && !excluded.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
                  {open === "queues" ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open === "queues"} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {/* new UI display */}
                    {
                      !legacyUI && (
                        <>
                        {/* new Queue Display Dropdown */}
                        <div className={newUi.sidebarFormRowDropdown}>
                          <div style={{flex: 1}}>
                            <span className={newUi.sidebarOptionLabel}>Display</span>
                            <select className={lightMode ? newUi.sidebarDropdown : newUi.sidebarDropdownDark} id="queue-display-label" value={queueDisplay} onChange={(event: any) => {
                              localStorage.setItem(`user-display-${rcId}`, event.target.value.toString())
                              setQueueDisplay(event.target.value.toString())
                            }}>
                              <option value="name-ext">Name (ext)</option>
                              <option value="ext-name">(ext) Name</option>
                            </select>
                          </div>
                        </div>
                        {/* new Queue Sort Field */}
                        <div className={newUi.sidebarFormRowDropdown}>
                            <div style={{width: '100%'}}>
                              <span className={newUi.sidebarOptionLabel}>Sort Field</span>
                              <select className={lightMode ? newUi.sidebarDropdown : newUi.sidebarDropdownDark} id="user-sort-field" value={queueSortField} 
                              onChange={(event: any) =>
                                setQueueSortField(event.target.value.toString())
                              }>
                                <option value="extensionNumber">Extension</option>
                                <option value="department">Department</option>
                                <option value="firstName">First Name</option>
                                <option value="lastName">Last Name</option>
                                <option value="message">Status</option>
                                <option value="presence">Presence</option>
                                <option value="queuePresence">Queue Presence</option>
                                <option value="elapsed-time">Elapsed Time</option>
                              </select>
                            </div>
                            <div className={newUi.ascDescButtonContainer} style={{display: "flex", flex: 1, justifyContent: 'end'}}>
                              {/* user sort direction */}
                              <button onClick={() => setQueueSortDirection((p) => p === "desc" ? "asc" : "desc")} className={newUi.ascDescButton} style={{...sidebarDescAscStyleHandler(lightMode), marginLeft: 10}} type="button">
                                {queueSortDirection}
                                {queueSortDirection === 'asc' ? <KeyboardArrowUp style={{color: lightMode? "black" :  "white"}} fontSize="small"  /> : <KeyboardArrowDown style={{color: lightMode? "black":  "white"}} fontSize="small"  />}
                              </button>
                            </div>
                          </div>
                        </>
                      )
                    }
                    {/* legacy Queue Display */}
                    {
                      legacyUI && (
                        <>
                         <ListItem>
                        <FormControl>
                          <InputLabel
                            style={{ color: "white" }}
                            htmlFor="queue-display-label"
                          >
                            Display
                          </InputLabel>
                          <NativeSelect
                            inputProps={{
                              id: "queue-display-label",
                            }}
                            classes={{
                              root:
                                mode === "dark" ? classes.selectDark : classes.select,
                              icon: mode === "dark" ? classes.iconDark : classes.icon,
                            }}
                            value={queueDisplay}
                            onChange={(event: any) =>
                              setQueueDisplay(event.target.value.toString())
                            }
                          >
                            <option value="name-ext">Name (ext)</option>
                            <option value="ext-name">(ext) Name</option>
                          </NativeSelect>
                        </FormControl>
                      
                      </ListItem>
                      {/* Legacy UI Sort Field */}
                      <ListItem>
                        <FormControl>
                          <InputLabel
                            style={{ color: "white" }}
                            htmlFor="queue-sort-field"
                          >
                            Sort Field
                          </InputLabel>
                          <NativeSelect
                            inputProps={{
                              id: "queue-sort-field",
                            }}
                            classes={{
                              root:
                                mode === "dark" ? classes.selectDark : classes.select,
                              icon: mode === "dark" ? classes.iconDark : classes.icon,
                            }}
                            value={queueSortField}
                            onChange={(event: any) =>
                              setQueueSortField(event.target.value.toString())
                            }
                          >
                            <option value="extensionNumber">Extension</option>
                            <option value="name">Name</option>
                            {/* {organizationId === "3154756020" && ( */}
                            <option value="waiting">Waiting</option>
                            {/* )} */}
                            {/* {organizationId === "3154756020" && ( */}
                            <option value="longestRinging">Longest Waiting</option>
                            {/* )} */}
                            {/* {organizationId === "3154756020" && ( */}
                            <option value="agentsAvailable">Agents Available</option>
                            {/* )} */}
                          </NativeSelect>
                        </FormControl>
                        <FormControl style={{ marginLeft: 10 }}>
                          <InputLabel
                            style={{ color: "white" }}
                            htmlFor="queue-sort-direction"
                          >
                            Sort Direction
                          </InputLabel>
                          <NativeSelect
                            inputProps={{
                              id: "queue-sort-direction",
                            }}
                            classes={{
                              root:
                                mode === "dark" ? classes.selectDark : classes.select,
                              icon: mode === "dark" ? classes.iconDark : classes.icon,
                            }}
                            value={queueSortDirection}
                            onChange={(event: any) =>
                              setQueueSortDirection(event.target.value.toString())
                            }
                          >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                          </NativeSelect>
                        </FormControl>
                      </ListItem>
                        </>
                      )
                    }
                    {
                    queueCompactView && (
                    <>
                      <ListItem
                      role="listitem"
                      aria-label="open cmopact widget metics view"
                      aria-hidden={false}
                      button
                      onClick={() => setCompactWidgetMetricsView(!compactWidgetMetricsView)}>
                      <ListItemText primary="Widget Metrics (Compact View)" />
                      {compactWidgetMetricsView ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Collapse in={compactWidgetMetricsView}>
                      <div style={{ display: 'flex', alignItems: 'center'}}>
                        <Checkbox
                          color="default"
                          style={{ color: "white", padding: 4, marginLeft: 22 }}
                          checked={compactWidgetMetrics !== undefined && compactWidgetMetrics.every((arr) => arr.visible) &&
                            compactWidgetMetrics.length > 0 
                          }
                          indeterminate={
                            compactWidgetMetrics !== undefined && compactWidgetMetrics!.some((arr) => arr.visible) &&
                            !compactWidgetMetrics!.every((arr) => arr.visible)
                          }                      
                          onClick={() => {
                            compactWidgetMetrics!.forEach((metric) => {
                              const {key, label} = metric;
                              return compactWidgetMetrics!.every((i) => i.visible) ? handleCompactQueueMetrics(metric, key, false) : handleCompactQueueMetrics(metric, key, true)
                            })
                          }}
                        />
                        <span style={{fontSize: '0.85em'}}>{!compactWidgetMetrics!.every((arr) => arr.visible) ? "(Select All)" : "(Select None)"}</span>
                      </div>
                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="compact-queue-metrics">
                          {(provided: any) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                            {compactWidgetMetrics !== undefined && compactWidgetMetrics.map((metric, i) => (
                                <Draggable key={metric.key} draggableId={metric.key} index={i}>
                                  {(providedInner: any) => (
                                    <div style={{marginLeft: 22, display: 'flex', alignItems: 'center'}} ref={providedInner.innerRef} 
                                      {...providedInner.draggableProps}>
                                      <Checkbox
                                        color="default"
                                        style={{ color: "white", padding: 4, marginLeft: 22 }}
                                        checked={compactWidgetMetrics !== undefined && !!compactWidgetMetrics.find((arr) => arr.key === metric.key)?.visible}
                                        onClick={() => handleCompactQueueMetrics(metric, metric.key, !metric.visible)}
                                      />
                                      <span {...providedInner.dragHandleProps} style={{letterSpacing: '-3px', paddingRight: 10, fontSize: '1.1em'}}>⋮⋮⋮⋮</span>
                                      <span style={{fontSize: '0.85em'}}>{metric.label}</span>
                                    </div>
                                  )}
                                </Draggable>
                              ))
                            }
                            {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                      </Collapse>
                    </>
                    )
                    }
                  
                    <View
                      viewType='queue'
                      historical={historicalQueues}
                      setSearch={setQueueSearch}
                      legacyUI={legacyUI}
                      search={queueSearch}
                      mySort={queueSort}
                      excluded={excluded}
                      format={queueFormatSidebar}
                      rcId={rcId}
                      searchFilters={["name", "extensionNumber"]}
                      blocked={blockedQueues}
                      setBlocked={setBlockedQueues}
                      mode={mode}
                      onItemClick={(historicalQueue: any) => {
                        setExcluded((myOldExcluded: Set<string> | undefined) => {
                          if (myOldExcluded === undefined) {
                            return undefined;
                          }

                          const myNewExcluded = new Set(myOldExcluded);

                          if (myOldExcluded.has(historicalQueue.id)) {
                            myNewExcluded.delete(historicalQueue.id);

                            setExcludedUsers((oldExcludedusers) => {
                              const myNewExcludedUsers = new Set(oldExcludedusers);

                              historicalQueue.users.forEach((myUser: any) => {
                                if (blocked.has(myUser.id)) {
                                  return;
                                }

                                myNewExcludedUsers.delete(myUser.id);
                              });
                              localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(myNewExcludedUsers)))
                              return myNewExcludedUsers;

                            });
                          } else {
                            myNewExcluded.add(historicalQueue.id);

                            setExcludedUsers((myOldExcludedUsers) => {
                              const myNewExcludedUsers = new Set(
                                myOldExcludedUsers
                              );

                              historicalQueue.users.forEach((myUser: any) => {
                                if (blocked.has(myUser.id)) {
                                  return;
                                }

                                if (
                                  !historicalQueues.find(
                                    (myQueue) =>
                                      myQueue.id !== historicalQueue.id &&
                                      !excluded.has(myQueue.id) &&
                                      !blockedQueues.has(myQueue.id) &&
                                      myQueue.users.find(
                                        (myQueueUser: any) =>
                                          myQueueUser.id === myUser.id
                                      )
                                  )
                                ) {
                                  myNewExcludedUsers.add(myUser.id);
                                }
                              });
                              localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(myNewExcludedUsers)))
                              return myNewExcludedUsers;
                            });
                          }
                          localStorage.setItem(`excluded-queues-${rcId}`, JSON.stringify(Array.from(myNewExcluded)))
                          return myNewExcluded;
                        });
                      }}
                      onAll={() => {
                        setExcluded(blockedQueues);
                        localStorage.setItem(`excluded-queues-${rcId}`, JSON.stringify(Array.from(blockedQueues)))
                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            localStorage.setItem(`excluded-queues-${rcId}`, "[]")
                            return undefined;
                          }
                          const newExcludedUsers = new Set(oldExcludedUsers);

                          historicalUsers.forEach((myUser) => {
                            if (blocked.has(myUser.id)) {
                              return;
                            }
                            if (
                              historicalQueues
                                .filter((myQueue) => !blockedQueues.has(myQueue.id))
                                .find((myQueue) =>
                                  myQueue.users.find(
                                    (myQueueUser: any) => myQueueUser.id === myUser.id
                                  )
                                )
                            ) {
                              newExcludedUsers.delete(myUser.id);
                            }
                          });
                          localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(newExcludedUsers)))
                          return newExcludedUsers;
                        });
                      }}
                      onNone={() => {
                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            localStorage.setItem(`excluded-queues-${rcId}`, "[]")
                            return undefined;
                          }
                          const newExcludedUsers = new Set(oldExcludedUsers);

                          setExcluded(() => {
                            const exc =  new Set(
                              historicalQueues
                                .valueSeq()
                                .map((historicalQueue) => {
                                  historicalQueue.users.forEach((myUser: any) => {
                                    if (blocked.has(myUser.id)) {
                                      return;
                                    }
                                    newExcludedUsers.add(myUser.id);
                                  });

                                  return historicalQueue.id.toString();
                                })
                            )
                            localStorage.setItem(`excluded-queues-${rcId}`, JSON.stringify(Array.from(exc)))
                            return exc;
                          }
                          );
                          localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(newExcludedUsers)))
                          return newExcludedUsers;
                        });
                      }}
                    />
                  </List>
                </Collapse>
                </>
              )
            }
          
            {/* AIR Filters */}
            {
              (tab === "air" || tab === "ivr") && (
                <>
                 <div style={{display: tab === 'ivr' ? "block" : "none"}}>
                 <ListItem
                  role="listitem"
                  aria-label="Open IVR filters"
                  aria-hidden={false}
                  button
                  onClick={() => {
                    setOpen((oldOpen) => (oldOpen === "ivr" ? "" : "ivr"));
                  }}
                >
                  <ListItemText primary="IVR" />
                  {!blockedIvrs.size && !excludedIvrs.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
                  {open === "ivr" ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open === "ivr"} timeout="auto">
                  <List component="div" disablePadding>
                     {/* Old Sort Field/Direction for IVR */}
                    {/* 
                     <ListItem>
                      <FormControl>
                        <InputLabel
                          style={{ color: "white" }}
                          htmlFor="ivr-sort-field"
                        >
                          Sort Field
                        </InputLabel>
                        <NativeSelect
                          inputProps={{
                            id: "ivr-sort-field",
                          }}
                          classes={{
                            root:
                              mode === "dark" ? classes.selectDark : classes.select,
                            icon: mode === "dark" ? classes.iconDark : classes.icon,
                          }}
                          value={ivrSortField}
                          onChange={(event: any) =>
                            setIvrSortField(event.target.value.toString())
                          }
                        >
                          <option value="extensionNumber">Extension</option>
                          <option value="name">Name</option>
                        </NativeSelect>
                      </FormControl> 
                      <FormControl style={{ marginLeft: 10 }}>
                        <InputLabel
                          style={{ color: "white" }}
                          htmlFor="ivr-sort-direction"
                        >
                          Sort Direction
                        </InputLabel>
                        <NativeSelect
                          inputProps={{
                            id: "ivr-sort-direction",
                          }}
                          classes={{
                            root:
                              mode === "dark" ? classes.selectDark : classes.select,
                            icon: mode === "dark" ? classes.iconDark : classes.icon,
                          }}
                          value={ivrSortDirection}
                          onChange={(event: any) =>
                            setIvrSortDirection(event.target.value.toString())
                          }
                        >
                          <option value="asc">Ascending</option>
                          <option value="desc">Descending</option>
                        </NativeSelect>
                      </FormControl>
                            </ListItem>
                      */}
                      {/* NEW UI for IVR Sort Field / Direction */}
                      <div className={newUi.sidebarFormRowDropdown}>
                        <div style={{width: '100%'}}>
                          <span className={newUi.sidebarOptionLabel}>Sort Field</span>
                          <select className={lightMode ? newUi.sidebarDropdown : newUi.sidebarDropdownDark} id="user-sort-field" value={ivrSortField} 
                          onChange={(event: any) => setIvrSortField(event.target.value.toString())}>
                            <option value="extensionNumber">Extension</option>
                            <option value="name">Name</option>
                          </select>
                        </div>
                        <div className={newUi.ascDescButtonContainer} style={{display: "flex", flex: 1, justifyContent: 'end'}}>
                          {/* user sort direction */}
                          <button onClick={() => setUserSortDirection((p) => p === "desc" ? "asc" : "desc")} className={newUi.ascDescButton} style={{...sidebarDescAscStyleHandler(lightMode), marginLeft: 10}} type="button">
                            {ivrSortDirection}
                            {ivrSortDirection === 'asc' ? <KeyboardArrowUp style={{color: lightMode? "black" :  "white"}} fontSize="small"  /> : <KeyboardArrowDown style={{color: lightMode? "black":  "white"}} fontSize="small"  />}
                          </button>
                        </div>
                      </div> 
                    <View
                    viewType={tab}
                    historical={historicalIvr.filter((ivr) => !ivr.isAir )}
                    legacyUI={legacyUI}
                    setSearch={setIvrSearch}
                    search={ivrSearch}
                    mySort={ivrSort}
                    excluded={excludedIvrs}
                    format={(historicalIvr_: HistoricalIvr) => historicalIvr_.name}
                    rcId={rcId}
                    searchFilters={[
                      "name",
                      "extensionNumber",
                    ]}
                    blocked={blockedIvrs}
                    setBlocked={setBlockedIvrs}
                    mode={mode}
                    onItemClick={(historicalIvr_: any) => {
                      setExcludedIvrs((oldexcluded) => {
                        const newExcluded = new Set(oldexcluded);
                        if (newExcluded.has(historicalIvr_.id)) {
                          newExcluded.delete(historicalIvr_.id);
                        } else {
                          newExcluded.add(historicalIvr_.id);
                        }
                        localStorage.setItem(`excluded-ivrs-${rcId}`, JSON.stringify(Array.from(newExcluded)))
                        return newExcluded;
                      });
                    }}
                    onAll={() => {
                      setExcludedIvrs(() => {
                        const exc = historicalIvr
                          .filter((historicalUser) => blockedIvrs.has(historicalUser.id))
                          .keySeq();
                          localStorage.setItem(`excluded-ivrs-${rcId}`, JSON.stringify(Array.from(exc)))

                        return new Set(exc); // Convert to a native Set
                      });
                    }}
                    onNone={() => {
                      const exc = new Set(historicalIvr.valueSeq().filter((ivr) => !ivr.isAir).map((histIvr) => histIvr.id).toArray())
                      localStorage.setItem(`excluded-ivrs-${rcId}`, JSON.stringify("[]"))
                      return setExcludedIvrs(exc)
                    }}
                  />
                  </List>
                </Collapse>
                </div>
                <div style={{display: tab === 'air' ? "block" : "none"}}>
                 <ListItem
                  role="listitem"
                  aria-label="Open AIR filters"
                  aria-hidden={false}
                  button
                  onClick={() => {
                    setOpen((oldOpen) => (oldOpen === "air" ? "" : "air"));
                  }}
                >
                  <ListItemText primary="AIR" />
                  {!blockedAirs.size && !excludedAirs.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
                  {open === "air" ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open === "air"} timeout="auto">
                  <List component="div" disablePadding>
                    {/* <ListItem>
                      <FormControl>
                        <InputLabel
                          style={{ color: "white" }}
                          htmlFor="ivr-sort-field"
                        >
                          Sort Field
                        </InputLabel>
                        <NativeSelect
                          inputProps={{
                            id: "ivr-sort-field",
                          }}
                          classes={{
                            root:
                              mode === "dark" ? classes.selectDark : classes.select,
                            icon: mode === "dark" ? classes.iconDark : classes.icon,
                          }}
                          value={airSortField}
                          onChange={(event: any) =>
                            setAirSortField(event.target.value.toString())
                          }
                        >
                          <option value="extensionNumber">Extension</option>
                          <option value="name">Name</option>
                        </NativeSelect>
                      </FormControl> 
                      <FormControl style={{ marginLeft: 10 }}>
                        <InputLabel
                          style={{ color: "white" }}
                          htmlFor="ivr-sort-direction"
                        >
                          Sort Direction
                        </InputLabel>
                        <NativeSelect
                          inputProps={{
                            id: "ivr-sort-direction",
                          }}
                          classes={{
                            root:
                              mode === "dark" ? classes.selectDark : classes.select,
                            icon: mode === "dark" ? classes.iconDark : classes.icon,
                          }}
                          value={airSortDirection}
                          onChange={(event: any) =>
                            setAirSortDirection(event.target.value.toString())
                          }
                        >
                          <option value="asc">Ascending</option>
                          <option value="desc">Descending</option>
                        </NativeSelect>
                      </FormControl>
                    </ListItem> */}
                    <div className={newUi.sidebarFormRowDropdown}>
                        <div style={{width: '100%'}}>
                          <span className={newUi.sidebarOptionLabel}>Sort Field</span>
                          <select className={lightMode ? newUi.sidebarDropdown : newUi.sidebarDropdownDark} id="user-sort-field" value={airSortField} 
                          onChange={(event: any) => setAirSortField(event.target.value.toString())}>
                            <option value="extensionNumber">Extension</option>
                            <option value="name">Name</option>
                          </select>
                        </div>
                        <div className={newUi.ascDescButtonContainer} style={{display: "flex", flex: 1, justifyContent: 'end'}}>
                          {/* user sort direction */}
                          <button onClick={() => setAirSortDirection((p) => p === "desc" ? "asc" : "desc")} className={newUi.ascDescButton} style={{...sidebarDescAscStyleHandler(lightMode), marginLeft: 10}} type="button">
                            {airSortDirection}
                            {airSortDirection === 'asc' ? <KeyboardArrowUp style={{color: lightMode? "black" :  "white"}} fontSize="small"  /> : <KeyboardArrowDown style={{color: lightMode? "black":  "white"}} fontSize="small"  />}
                          </button>
                        </div>
                      </div> 
                    <View
                    viewType={tab}
                    historical={historicalIvr.filter((ivr) => ivr.isAir )}
                    legacyUI={legacyUI}
                    setSearch={setAirSearch}
                    search={airSearch}
                    mySort={airSort}
                    excluded={excludedAirs}
                    format={(historicalIvr_: HistoricalIvr) => historicalIvr_.name}
                    rcId={rcId}
                    searchFilters={[
                      "name",
                      "extensionNumber",
                    ]}
                    blocked={blockedAirs}
                    setBlocked={setBlockedAirs}
                    mode={mode}
                    onItemClick={(historicalIvr_: any) => {
                      setExcludedAirs((oldexcluded) => {
                        const newExcluded = new Set(oldexcluded);
                        if (newExcluded.has(historicalIvr_.id)) {
                          newExcluded.delete(historicalIvr_.id);
                        } else {
                          newExcluded.add(historicalIvr_.id);
                        }
                        localStorage.setItem(`excluded-ivrs-${rcId}`, JSON.stringify(Array.from(newExcluded)))
                        return newExcluded;
                      });
                    }}
                    onAll={() => {
                      setExcludedAirs(() => {
                        const exc = historicalIvr
                          .filter((air) => blockedAirs.has(air.id))
                          .keySeq();
                          localStorage.setItem(`excluded-ivrs-${rcId}`, JSON.stringify(Array.from(exc)))

                        return new Set(exc); // Convert to a native Set
                      });
                    }}
                    onNone={() => {
                      const exc = new Set(historicalIvr.valueSeq().filter((ivr) => ivr.isAir).map((histIvr) => histIvr.id).toArray())
                      localStorage.setItem(`excluded-ivrs-${rcId}`, JSON.stringify("[]"))
                      return setExcludedAirs(exc)
                    }}
                  />
                  </List>
                </Collapse>
                </div>
                </>
              )
            }
          
          
            {tab === "users" && (
              <>
                <ListItem
                  role="listitem"
                  aria-label="Open departments filters"
                  aria-hidden={false}
                  button
                  onClick={() => {
                    setOpen((oldOpen) =>
                      oldOpen === "departments" ? "" : "departments"
                    );
                  }}
                >
                  <ListItemText primary="Departments" />
                  {!blockedDepartments.size && !excludedDepartments.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
                  {open === "departments" ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse
                  in={open === "departments"}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                  <ListItem>
                    {
                      legacyUI && (
                        <FormControl>
                        <InputLabel
                          style={{ color: "white" }}
                          htmlFor="queue-sort-direction"
                        >
                          Sort Direction
                        </InputLabel>
                        <NativeSelect
                          inputProps={{
                            id: "department-sort-direction",
                          }}
                          classes={{
                            root:
                              mode === "dark"
                                ? classes.selectDark
                                : classes.select,
                            icon:
                              mode === "dark" ? classes.iconDark : classes.icon,
                          }}
                          value={departmentSortDirection}
                          onChange={(event: any) =>
                            setDepartmentSortDirection(
                              event.target.value.toString()
                            )
                          }
                        >
                          <option value="asc">Ascending</option>
                          <option value="desc">Descending</option>
                        </NativeSelect>
                      </FormControl>
                      )
                    }
                    {
                      !legacyUI && (
                        <div className={newUi.ascDescButtonContainer} style={{display: "flex", flex: 1, justifyContent: 'end'}}>
                          {/* user sort direction */}
                          <button onClick={() => setDepartmentSortDirection((p) => p === "desc" ? "asc" : "desc")} className={newUi.ascDescButton} style={{...sidebarDescAscStyleHandler(lightMode), marginLeft: 10}} type="button">
                          {departmentSortDirection}
                          {departmentSortDirection === 'asc' ? <KeyboardArrowUp style={{color: lightMode? "black" :  "white"}} fontSize="small"  /> : <KeyboardArrowDown style={{color: lightMode? "black":  "white"}} fontSize="small"  />}
                          </button>
                        </div>
                      )
                    }                     
                    </ListItem>
                    <View
                      viewType="departments"
                      legacyUI={legacyUI}
                      historical={historicalDepartments}
                      setSearch={setDepartmentSearch}
                      search={departmentSearch}
                      mySort={departmentSort}
                      excluded={excludedDepartments}
                      rcId={rcId}
                      format={(historicalDepartment: any) => historicalDepartment.name}
                      searchFilters={["name"]}
                      blocked={blockedDepartments}
                      setBlocked={setBlockedDepartments}
                      mode={mode}
                      onItemClick={(historicalDepartment: any) => {
                        setExcludedDepartments((oldExcludedDepartments: Set<string> | undefined) => {
                          if (oldExcludedDepartments === undefined) {
                            return undefined;
                          }

                          const myNewExcludedDepartments = new Set(oldExcludedDepartments);

                          if (oldExcludedDepartments.has(historicalDepartment.id)) {
                            myNewExcludedDepartments.delete(historicalDepartment.id);

                            setExcludedUsers((myOldExcludedUsers) => {
                              const myNewExcludedUsers = new Set(myOldExcludedUsers);

                              historicalUsers
                                .valueSeq()
                                .filter(
                                  (myUser) =>
                                    !blocked.has(myUser.id) &&
                                    myUser.department === historicalDepartment.id
                                )
                                .forEach((myUser: any) => {
                                  myNewExcludedUsers.delete(myUser.id);
                                });
                                localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(myNewExcludedUsers)))
                              return myNewExcludedUsers;
                            });
                          } else {
                            myNewExcludedDepartments.add(historicalDepartment.id);

                            setExcludedUsers((myOldExcludedUsers) => {
                              const myNewExcludedUsers = new Set(myOldExcludedUsers);

                              historicalUsers
                                .valueSeq()
                                .filter(
                                  (myUser) =>
                                    !blocked.has(myUser.id) &&
                                    myUser.department === historicalDepartment.id
                                )
                                .forEach((myUser: any) => {
                                  myNewExcludedUsers.add(myUser.id);
                                });
                                localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(myNewExcludedUsers)))
                              return myNewExcludedUsers;
                            });
                          }
                          localStorage.setItem(`excluded-departments-${rcId}`, JSON.stringify(Array.from(myNewExcludedDepartments)))
                          return myNewExcludedDepartments;
                        });
                      }}
                      onAll={() => {
                        setExcludedDepartments(blockedDepartments);
                        localStorage.setItem(`excluded-departments-${rcId}`, JSON.stringify(Array.from(blockedDepartments)))

                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            return undefined;
                          }

                          const newExcludedUsers = new Set(oldExcludedUsers);

                          historicalUsers.forEach((myUser) => {
                            if (blocked.has(myUser.id)) {
                              return;
                            }
                            if (!blockedDepartments.has(myUser.department)) {
                              newExcludedUsers.delete(myUser.id);
                            }
                          });
                          localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(newExcludedUsers)))
                          return newExcludedUsers;
                        });
                      }}
                      onNone={() => {
                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            return undefined;
                          }

                          const newExcludedUsers = new Set(oldExcludedUsers);

                          historicalUsers.forEach((myUser) => {
                            if (blocked.has(myUser.id)) {
                              return;
                            }

                            if (blockedDepartments.has(myUser.department)) {
                              return;
                            }

                            newExcludedUsers.add(myUser.id);
                          });
                          localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(newExcludedUsers)))
                          return newExcludedUsers;
                        });

                        setExcludedDepartments(() => {
                          const exc = new Set(
                            historicalDepartments
                              .valueSeq()
                              .filter(
                                (historicalDepartment) =>
                                  !blockedDepartments.has(historicalDepartment.id)
                              )
                              .map((historicalDepartment) => historicalDepartment.id)
                          )
                          localStorage.setItem(`excluded-departments-${rcId}`, JSON.stringify(Array.from(exc)))
                          return exc;
                        }
                        );
                      }}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {tab === "users" && historicalLocations !== undefined && (
              <>
                <ListItem
                  role="listitem"
                  aria-label="Open location filters"
                  aria-hidden={false}
                  button
                  onClick={() => {
                    setOpen((oldOpen) =>
                      oldOpen === "locations" ? "" : "locations"
                    );
                  }}
                >
                  <ListItemText primary="Sites" />
                  {!blockedLocations.size && !excludedLocations.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
                  {open === "locations" ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse
                  in={open === "locations"}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    <ListItem>
                     {
                      legacyUI && (
                        <FormControl>
                        <InputLabel style={{ color: "white" }} htmlFor="queue-sort-direction">
                          Sort Direction
                        </InputLabel>
                        <NativeSelect inputProps={{id: "location-sort-direction"}}
                          classes={{ root: mode === "dark" ? classes.selectDark : classes.select,
                            icon: mode === "dark" ? classes.iconDark : classes.icon}}
                          value={locationSortDirection}
                          onChange={(event: any) => setLocationSortDirection(event.target.value.toString())}>
                          <option value="asc">Ascending</option>
                          <option value="desc">Descending</option>
                        </NativeSelect>
                      </FormControl>
                      )
                      }
                      {
                      !legacyUI && (
                        <div className={newUi.ascDescButtonContainer} style={{display: "flex", flex: 1, justifyContent: 'end'}}>
                          {/* user sort direction */}
                          <button onClick={() => setLocationSortDirection((p) => p === "desc" ? "asc" : "desc")} className={newUi.ascDescButton} style={{...sidebarDescAscStyleHandler(lightMode), marginLeft: 10}} type="button">
                          {locationSortDirection}
                          {locationSortDirection === 'asc' ? <KeyboardArrowUp style={{color: lightMode? "black" :  "white"}} fontSize="small"  /> : <KeyboardArrowDown style={{color: lightMode? "black":  "white"}} fontSize="small"  />}
                          </button>
                        </div>
                      )
                    } 
                    </ListItem>
                    <View
                      viewType='locations'
                      legacyUI={legacyUI}
                      historical={historicalLocations}
                      setSearch={setLocationSearch}
                      search={locationSearch}
                      mySort={locationSort}
                      excluded={excludedLocations}
                      rcId={rcId}
                      format={(historicalLocation: any) => historicalLocation.name}
                      searchFilters={["name"]}
                      blocked={blockedLocations}
                      setBlocked={setBlockedLocations}
                      mode={mode}
                      onItemClick={(historicalLocation: any) => {
                        setExcludedLocations((myOldExcludedLocations: Set<string> | undefined) => {
                          if (myOldExcludedLocations === undefined) {
                            return undefined;
                          }

                          const myNewExcludedLocations = new Set(myOldExcludedLocations);

                          if (myOldExcludedLocations.has(historicalLocation.id)) {
                            myNewExcludedLocations.delete(historicalLocation.id);

                            setExcludedUsers((myOldExcludedUsers) => {
                              const myNewExcludedUsers = new Set(myOldExcludedUsers);

                              historicalUsers
                                .valueSeq()
                                .filter(
                                  (myUser) =>
                                    !blocked.has(myUser.id) &&
                                    myUser.site?.name === historicalLocation.id
                                )
                                .forEach((myUser: any) => {
                                  myNewExcludedUsers.delete(myUser.id);
                                });
                                localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(myNewExcludedUsers)))
                              return myNewExcludedUsers;
                            });
                          } else {
                            myNewExcludedLocations.add(historicalLocation.id);

                            setExcludedUsers((myOldExcludedUsers) => {
                              const myNewExcludedUsers = new Set(myOldExcludedUsers);

                              historicalUsers
                                .valueSeq()
                                .filter(
                                  (myUser) =>
                                    !blocked.has(myUser.id) &&
                                    myUser.site?.name === historicalLocation.id
                                )
                                .forEach((myUser: any) => {
                                  myNewExcludedUsers.add(myUser.id);
                                });
                                localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(myNewExcludedUsers)))
                              return myNewExcludedUsers;
                            });
                          }
                          localStorage.setItem(`excluded-locations-${rcId}`, JSON.stringify(Array.from(myNewExcludedLocations)))
                          return myNewExcludedLocations;
                        });
                      }}
                      onAll={() => {
                        setExcludedLocations(blockedLocations);
                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            return undefined;
                          }
                          const newExcludedUsers = new Set(oldExcludedUsers);

                          historicalUsers
                            .valueSeq()
                            .forEach((myUser) => {
                              if (blocked.has(myUser.id)) {
                                return;
                              }
                              if (!blockedLocations.has(myUser.site?.name)) {
                                newExcludedUsers.delete(myUser.id);
                              }
                            });
                            localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(newExcludedUsers)))
                          return newExcludedUsers;
                        });
                      }}
                      onNone={() => {
                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            return undefined;
                          }
                          const newExcludedUsers = new Set(oldExcludedUsers);

                          historicalUsers
                            .valueSeq()
                            .forEach((myUser) => {
                              if (blocked.has(myUser.id)) {
                                return;
                              }

                              if (blockedLocations.has(myUser.site?.name)) {
                                return;
                              }

                              newExcludedUsers.add(myUser.id);
                            });
                            localStorage.setItem(`excluded-users-${rcId}`, JSON.stringify(Array.from(newExcludedUsers)))

                          return newExcludedUsers;
                        });

                        setExcludedLocations(() => {
                          const exc = new Set(
                            historicalLocations
                              .valueSeq()
                              .filter(
                                (historicalLocation) =>
                                  !blockedLocations.has(historicalLocation.id)
                              )
                              .map((historicalLocation) => historicalLocation.id)
                          )
                          localStorage.setItem(`excluded-locations-${rcId}`, JSON.stringify(Array.from(exc)))
                          return exc;
                        });
                      }}
                    />

                  </List>
                </Collapse>
              </>
            )}
            {tab === "users" && historicalFacilities && organizationId === "340386037" && (
              <>
                <ListItem
                  role="listitem"
                  aria-label="Open facility filters"
                  aria-hidden={false}
                  button
                  onClick={() => {
                    setOpen((oldOpen) =>
                      oldOpen === "facility" ? "" : "facility"
                    );
                  }}
                >
                  <ListItemText primary="Facilities" />
                  {!blockedFacilities.size && !excludedFacilities.size  ? <></> : <FilterList fontSize="small" style={{color: 'white'}} />}
                  {open === "facility" ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse
                  in={open === "facility"}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    <ListItem>
                      <FormControl>
                        <InputLabel
                          style={{ color: "white" }}
                          htmlFor="queue-sort-direction"
                        >
                          Sort Direction
                        </InputLabel>
                        <NativeSelect
                          inputProps={{
                            id: "facility-sort-direction",
                          }}
                          classes={{
                            root:
                              mode === "dark"
                                ? classes.selectDark
                                : classes.select,
                            icon:
                              mode === "dark" ? classes.iconDark : classes.icon,
                          }}
                          value={facilitySortDirection}
                          onChange={(event: any) =>
                            setFacilitySortDirection(
                              event.target.value.toString()
                            )
                          }
                        >
                          <option value="asc">Ascending</option>
                          <option value="desc">Descending</option>
                        </NativeSelect>
                      </FormControl>
                    </ListItem>
                    <View
                      viewType="facilities"
                      legacyUI={legacyUI}
                      historical={historicalFacilities}
                      setSearch={setFacilitySearch}
                      search={facilitySearch}
                      mySort={facilitySort}
                      rcId={rcId}
                      excluded={excludedFacilities}
                      format={(facility: any) => facility.id}
                      searchFilters={["name"]}
                      blocked={blockedFacilities}
                      setBlocked={setBlockedFacilities}
                      mode={mode}
                      onItemClick={(facility: any) => {
                        setExcludedFacilities((myOldExcluded: Set<string> | undefined) => {
                          if (myOldExcluded === undefined) {
                            return new Set<string>();
                          }

                          const myNewExcluded = new Set(myOldExcluded);

                          if (myOldExcluded.has(facility.id)) {
                            myNewExcluded.delete(facility.id);

                            setExcludedUsers((myOldExcludedUsers) => {
                              const myNewExcludedUsers = new Set(myOldExcludedUsers);

                              historicalUsers
                                .valueSeq()
                                .filter(
                                  (myUser) =>
                                    !blocked.has(myUser.id) && myUser.facilityId === facility.id
                                )
                                .forEach((myUser: any) => {
                                  myNewExcludedUsers.delete(myUser.id);
                                });

                              return myNewExcludedUsers;
                            });
                          } else {
                            myNewExcluded.add(facility.id);

                            setExcludedUsers((myOldExcludedUsers) => {
                              const myNewExcludedUsers = new Set(myOldExcludedUsers);

                              historicalUsers
                                .valueSeq()
                                .filter(
                                  (myUser) =>
                                    !blocked.has(myUser.id) && myUser.facilityId === facility.id
                                )
                                .forEach((myUser: any) => {
                                  myNewExcludedUsers.add(myUser.id);
                                });

                              return myNewExcludedUsers;
                            });
                          }

                          return myNewExcluded;
                        });
                      }}
                      onAll={() => {
                        setExcludedFacilities(blockedFacilities);
                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            return undefined;
                          }
                          const newExcludedUsers = new Set(oldExcludedUsers);

                          historicalUsers
                            .valueSeq()
                            .forEach((myUser) => {
                              if (blocked.has(myUser.id)) {
                                return;
                              }
                              if (!blockedFacilities.has(myUser.facilityId)) {
                                newExcludedUsers.delete(myUser.id);
                              }
                            });

                          return newExcludedUsers;
                        });
                      }}
                      onNone={() => {
                        setExcludedUsers((oldExcludedUsers: Set<string> | undefined) => {
                          if (oldExcludedUsers === undefined) {
                            return undefined;
                          }
                          const newExcludedUsers = new Set(oldExcludedUsers);

                          historicalUsers
                            .valueSeq()
                            .forEach((myUser) => {
                              if (blocked.has(myUser.id)) {
                                return;
                              }

                              if (blockedFacilities.has(myUser.facilityId)) {
                                return;
                              }

                              newExcludedUsers.add(myUser.id);
                            });

                          return newExcludedUsers;
                        });

                        setExcludedFacilities(
                          new Set(
                            historicalFacilities
                              .valueSeq()
                              .filter(
                                (facility: any) => !blockedFacilities.has(facility.id)
                              )
                              .map((facility: any) => facility.id)
                          )
                        );
                      }}
                    />

                  </List>
                </Collapse>
              </>
            )}
             {/* <ActiveFilterView orgId={organizationId} typeOfDisplay={page} filterRef={activeFilterRef} mode={mode} /> */}
            <div className="sidebar-buffer" />
          </List>
        )}
      {tab === "queues" && (
        <div style={{display: fullscreen ? "none" : 'flex', alignItems: 'center', paddingTop: 10}} className={`queue-toolbar ${mode === 'light' ? "light-mode" : "dark-mode"} ${sidebar ? "sidebar-open" : ""}`}>
        <Button
          className="queue-bar"
          // variant="text"
          disableRipple
          style={
            mode === "dark"
              ? {
                color: "white",
                backgroundColor: "transparent",
                height: 30,
                textTransform: 'none'
              }
              : {
                color: "black",
                height: 30,
                backgroundColor: "transparent",
                textTransform: 'none'
              }
          }
          onClick={() => setExpandQueues(!expandQueues)}
          startIcon={
            expandQueues ? (
              <ExpandLess style={mode === "dark" ? { color: "white" } : {}} />
            ) : (
              <ExpandMore style={mode === "dark" ? { color: "white" } : {}} />
            )
          }
        >
          Queues
        </Button>
         {
          expandQueues && (
            <span style={{display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between'}}>
              <div className={`compact-view-selector-container ${mode === 'light' ? "light-mode" : "dark-mode"}`}>
                <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"} ${!queueCompactView ? "selected" : ""}`} onClick={() => handleQueueCompactView(false)}>
                  <Apps   /> Widget View
                </button>
                <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"} ${queueCompactView ? "selected" : ""}`} onClick={() => handleQueueCompactView(true)}>
                  <Reorder   /> Compact View
                </button>
              </div>
              <button type='button' className={`compact-view-selector-item ${mode === 'light' ? "light" : "dark"}`}  onClick={() => setFullscreen((prev) => prev === "queues" ? undefined : "queues")} color={mode === 'light' ? "black" : "white"}>
                <Fullscreen style={{color: mode === 'light' ? "#0684bd" : "white"}} />
                Fullscreen
              </button>
            </span>
          )
         }
   
        </div>
      )}
      <div className={sidebar ? classes.widgetPanel : ""}>
        <div style={{ clear: "both" }} />
        {leaderboards && excludedUsers && (
          // allData &&
          <div
            style={
              tab === "users" && showLeaderboards ? {paddingTop: 0} : {paddingTop: 0, display: "none"}}
            className={ sidebar ? classes.leaderboardSidebar : classes.leaderboard}
          >
            <NewLeaderboard
              // for headlines
              setUserLeaderboardApi={setUserLeaderboardApi}
              headlinesAnchorEl={headlinesAnchorEl}
              setHeadlinesAnchorEl={setHeadlinesAnchorEl}
              sidebar={sidebar}
              historicals={historicals}
              displayHeadlines={displayHeadlines}
              setDisplayHeadlines={setDisplayHeadlines}
              orgId={organizationId}
              // ...
              
              smsData={smsData}
              leaderboardDeltas={leaderboardDeltas}
              historicalUsers={historicalUsers}
              mode={mode}
              tab={tab}
              rcId={rcId}
              adminClick={adminClick}
              navPage={navPage}
              hasRingCx={hasRingCx}
              cxAgents={cxAgents}
              widgetData={widgetData}
              blocked={blocked}
              setExcludedUsers={setExcludedUsers}
              setExcluded={setExcluded}
              setExcludedDepartments={setExcludedDepartments}
              setExcludedFacilities={setExcludedFacilities}
              setExcludedLocations={setExcludedLocations}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              isAdmin={isAdmin}
            />

        </div>

        )}
        {tab === "users" && (
          <div style={{paddingTop: 10, display: fullscreen ? "none" : 'flex', alignItems: 'center', justifyContent: 'start'}} className={`queue-toolbar user-bar ${mode === 'light' ? "light-mode" : "dark-mode"} ${sidebar ? "sidebar-open" : ""}`}>
          <Button
            className="users-bar"
            // variant="text"
            disableRipple
            style={
              mode === "dark"
                ? {
                  color: "white",
                  backgroundColor: "transparent",
                  height: 30,
                  textTransform: 'none'
                }
                : {
                  color: "black",
                  height: 30,
                  backgroundColor: "transparent",
                  textTransform: 'none'
                }
            }
            onClick={() => setExpandUsers(!expandUsers)}
            startIcon={
              expandUsers ? (
                <ExpandLess style={mode === "dark" ? { color: "white" } : {}} />
              ) : (
                <ExpandMore style={mode === "dark" ? { color: "white" } : {}} />
              )
            }
          >
            Users
          </Button>
          {
            expandUsers && (
              <span style={{display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between'}}>
                {/* <div className={`compact-view-selector-container ${mode === 'light' ? "light-mode" : "dark-mode"}`}>
                  <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"} ${!queueCompactView ? "selected" : ""}`} onClick={() => handleQueueCompactView(false)}>
                    <Apps   /> Default View
                  </button>
                  <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"} ${queueCompactView ? "selected" : ""}`} onClick={() => handleQueueCompactView(true)}>
                    <Reorder   /> Department View
                  </button>
                </div> */}
                <div />
                <button type='button' className={`compact-view-selector-item ${mode === 'light' ? "light" : "dark"}`}  onClick={() => setFullscreen((prev) => prev === "queues" ? undefined : "queues")} color={mode === 'light' ? "black" : "white"}>
                  <Fullscreen style={{color: mode === 'light' ? "#0684bd" : "white"}} />
                  Fullscreen
                </button>
              </span>
            )
          }
    
          </div>
        )}
      {/* users bar */}

        {/* {widgetData && !legacyUI && <Groups data={widgetData as IWidgetData[]} />} */}
        <div className={`${fullscreen === 'queues' ? "fullscreen" : ""} ${mode === 'light' ? "light" : "dark"}`} 
        // style={{zIndex: 1000000000000000}}
        >
        {(fullscreen === 'queues') && <CompactViewHeader closeFullscreen={() => setFullscreen(undefined)} mode={mode} />}
        <Collapse
          in={expandQueues}
          timeout="auto"
          style={
            tab === "queues" &&
              id &&
              excluded &&
              checked &&
              queueSort
              ? {position: 'relative'}
              : { display: "none", position: "absolute" }
          }
        >
          <QueueWidgetContainer
            fullscreen={fullscreen}
            setFullscreen={setFullscreen}
            excluded={new Set([...excluded || new Set(), ...blocked || new Set()])}
            historicalQueues={historicalQueues}
            mode={mode}
            queueCallStates={queueCallStates}
            leaderboardDeltas={leaderboardDeltas}
            userState={userState}
            sidebar={sidebar}
            legacy={legacyUI}
            historicalUsers={historicalUsers}
            toggledQueues={toggledQueues}
            setToggledQueues={setToggledQueues}
            queueCompactView={queueCompactView}
            setLiveQueueMetrics={setLiveQueueMetrics}
            userSortOrder={userSortField}
            userSortDirection={userSortDirection}
            userSortField={userSortField}
            adminClick={adminClick}
            queueDisplay={queueDisplay}
            queueSortField={queueSortField}
            queueSortOrder={queueSortDirection}
            showPortraits={showPortraits}
            compactWidgetMetrics={compactWidgetMetrics}
            showDnd={showDnd}
            showBusy={showBusy}
            showInvisible={showInvisible}
            showAvailable={showAvailable}
            setQueueCallStates={setQueueCallStates}
            orgId={organizationId}
            />
        </Collapse>
        {tab === "queues" && widgetData &&
          showPortraits !== undefined &&
          widgetData
            .filter(
              (myUser) =>
                (tab !== "queues" ) ||
                myUser.queues?.find((queue) => toggledQueues?.has(queue.queueId))
            )
            .sort((a, b) => (b.emergency ? 1 : 0) - (a.emergency ? 1 : 0))
            .slice(0, doubleWidgets ? 200 : 100)
            .map((myUser, i) =>
              <div
                style={{display: tab === 'queues' && queueCompactView ? "none" : ""}}
                key={myUser.id}
                className={
                  sidebar ? classes.widgetCellSidebar : classes.widgetCell
                }
                aria-hidden={false}
                role="listitem"
                aria-label="User"
              >
                <UserWidget
                  rcAccessToken={rcAccessToken}
                  timingFormat={`${i * 10}ms`}
                  user={myUser}
                  userFormat={userFormat}
                  orgId={organizationId}
                  setDialer={setDialer}
                  isCurrentUser={myUser.id === rcId}
                  isAdmin={isAdmin}
                  showPortraits={showPortraits}
                  browserPhone={changeTab !== undefined}
                  hasPresenceTimer={hasPresenceTimer}
                  elapsedTime={elapsedTime}
                  offset={offset}
                  mode={mode}
                  adminClick={adminClick} // what shoud happen when user is admin and click on the user widget
                  clickOnMessage={clickOnMessage} // what should happen when click on the message icon on the user widget
                  clickOnPhone={clickOnPhone} // what should happen when click on the phone icon on the user widget
                  clickOnHand={clickOnHand}
                  handRaised={myUser.emergency || false}
                  showHandRaise={showHandRaise}
                  supervise={supervise}
                  handlePopupToggle={() => handlePopupToggle(myUser.id)}
                  popperOpen={openPopperUserId === myUser.id}
                  origin={origin}
                  vipList={vipList}
                  userState={userStates.get(myUser.id)}
                  late={myUser.late}
                />
              </div>
            )}
            {
              tab === "users" && expandUsers &&
              widgetData &&
                showPortraits !== undefined &&
                widgetData
                  .sort((a, b) => (b.emergency ? 1 : 0) - (a.emergency ? 1 : 0))
                  .slice(0, doubleWidgets ? 200 : 100)
                  .map((myUser, i) =>
                    <div
                      style={{
                        // display: queueCompactView ? "none" : ""
                      }}
                      key={myUser.id}
                      className={
                        sidebar ? classes.widgetCellSidebar : classes.widgetCell
                      }
                      aria-hidden={false}
                      role="listitem"
                      aria-label="User"
                    >
                      <UserWidget
                        rcAccessToken={rcAccessToken}
                        timingFormat={`${i * 10}ms`}
                        user={myUser}
                        userFormat={userFormat}
                        orgId={organizationId}
                        setDialer={setDialer}
                        isCurrentUser={myUser.id === rcId}
                        isAdmin={isAdmin}
                        showPortraits={showPortraits}
                        browserPhone={changeTab !== undefined}
                        hasPresenceTimer={hasPresenceTimer}
                        elapsedTime={elapsedTime}
                        offset={offset}
                        mode={mode}
                        adminClick={adminClick} // what shoud happen when user is admin and click on the user widget
                        clickOnMessage={clickOnMessage} // what should happen when click on the message icon on the user widget
                        clickOnPhone={clickOnPhone} // what should happen when click on the phone icon on the user widget
                        clickOnHand={clickOnHand}
                        handRaised={myUser.emergency || false}
                        showHandRaise={showHandRaise}
                        supervise={supervise}
                        handlePopupToggle={() => handlePopupToggle(myUser.id)}
                        popperOpen={openPopperUserId === myUser.id}
                        origin={origin}
                        vipList={vipList}
                        userState={userStates.get(myUser.id)}
                        late={myUser.late}
                      />
                    </div>
                  )}
        </div>
      </div>
      {ivrSummary && (
        <IvrHud 
          historicalIvr={historicalIvr}
          ivrDeltas={ivrDeltas}
          ivrStates={ivrStates}
          mode={mode}
          tab={tab}
          page={page}
          sidebar={sidebar}
          excludedAirs={excludedAirs}
          excludedIvrs={excludedIvrs}
          showLeaderboards={showLeaderboards}
          fullscreen={fullscreen}
          setFullscreen={setFullscreen}
          accessToken={rcAccessToken}
          airSortDirection={airSortDirection}
          airSortField={airSortField}
          ivrSortDirection={ivrSortDirection}
          ivrSortField={ivrSortField}
        />
      )}
    </>
  );
});
Hud.displayName = "Hud";
export default Hud;

export type { CallSummaryEvent };
